(() => {
  if (window.__imModalControllerInitialized) return;
  window.__imModalControllerInitialized = true;

  const quoteModal = document.querySelector('[data-im-modal="quote"]');
  const sampleModal = document.querySelector('[data-im-modal="sample"]');
  if (!quoteModal && !sampleModal) return;

  const QUOTE_STORAGE_KEY = 'im_quote_items_v1';
  const QUOTE_DRAFT_STORAGE_KEY = 'im_quote_draft_v1';
  const QUOTE_EMAIL_HISTORY_STORAGE_KEY = 'im_quote_email_history_v1';
  const QUOTE_EMAIL_HISTORY_LIMIT = 5;
  const quoteForm = quoteModal ? quoteModal.querySelector('form') : null;
  const quoteProductsContainer = quoteModal ? quoteModal.querySelector('[data-im-quote-products]') : null;
  const quoteLoadAllButton = quoteModal ? quoteModal.querySelector('[data-im-quote-load-all]') : null;
  const quoteSearchInput = quoteModal ? quoteModal.querySelector('[data-im-quote-search-input]') : null;
  const quoteSearchResults = quoteModal ? quoteModal.querySelector('[data-im-quote-search-results]') : null;
  const quoteEmailSuggestions = quoteModal ? quoteModal.querySelector('[data-im-quote-email-suggestions]') : null;
  const quoteProductsError = quoteModal ? quoteModal.querySelector('[data-im-quote-products-error]') : null;
  const quoteProductsInput = quoteModal ? quoteModal.querySelector('[data-im-quote-products-input]') : null;
  const quoteWizardSteps = quoteModal ? Array.from(quoteModal.querySelectorAll('[data-im-step]')) : [];
  const quoteWizardProgress = quoteModal ? quoteModal.querySelector('[data-im-wizard-progress]') : null;
  const quoteWizardProgressFill = quoteModal ? quoteModal.querySelector('[data-im-wizard-progress-fill]') : null;
  const quoteWizardBackButton = quoteModal ? quoteModal.querySelector('[data-im-wizard-back]') : null;
  const quoteWizardNextButton = quoteModal ? quoteModal.querySelector('[data-im-wizard-next]') : null;
  const quoteWizardSubmitButton = quoteModal ? quoteModal.querySelector('[data-im-wizard-submit]') : null;
  const quoteWizardFallbackSubmit = quoteModal ? quoteModal.querySelector('[data-im-wizard-fallback-submit]') : null;
  const quoteStatusRegion = quoteModal ? quoteModal.querySelector('[data-im-quote-status]') : null;
  const quoteConsentField = quoteModal ? quoteModal.querySelector('#im-quote-consent') : null;
  const quoteModalTitleNode = quoteModal ? quoteModal.querySelector('.im-modal__title') : null;
  const quoteModalDescriptionNode = quoteModal ? quoteModal.querySelector('.im-modal__description') : null;
  const sampleForm = sampleModal ? sampleModal.querySelector('form') : null;
  const sampleModalPanel = sampleModal ? sampleModal.querySelector('.im-modal__panel') : null;
  const sampleModalBody = sampleModal ? sampleModal.querySelector('.im-modal__body') : null;
  const sampleLinesContainer = sampleModal ? sampleModal.querySelector('[data-im-sample-lines]') : null;
  const sampleLinesError = sampleModal ? sampleModal.querySelector('[data-im-sample-lines-error]') : null;
  const sampleSearchInput = sampleModal ? sampleModal.querySelector('[data-im-sample-search-input]') : null;
  const sampleSearchResults = sampleModal ? sampleModal.querySelector('[data-im-sample-search-results]') : null;
  const sampleLoadAllButton = sampleModal ? sampleModal.querySelector('[data-im-sample-load-all]') : null;
  const sampleStatusRegion = sampleModal ? sampleModal.querySelector('[data-im-sample-status]') : null;
  const sampleWizardSteps = sampleModal ? Array.from(sampleModal.querySelectorAll('[data-im-sample-step]')) : [];
  const sampleWizardProgress = sampleModal ? sampleModal.querySelector('[data-im-sample-progress]') : null;
  const sampleWizardProgressFill = sampleModal ? sampleModal.querySelector('[data-im-sample-progress-fill]') : null;
  const sampleWizardBackButton = sampleModal ? sampleModal.querySelector('[data-im-sample-back]') : null;
  const sampleWizardNextButton = sampleModal ? sampleModal.querySelector('[data-im-sample-next]') : null;
  const sampleWizardSubmitButton = sampleModal ? sampleModal.querySelector('[data-im-sample-submit]') : null;
  const sampleWizardFallbackSubmit = sampleModal ? sampleModal.querySelector('[data-im-sample-fallback-submit]') : null;
  const sampleConsentField = sampleModal ? sampleModal.querySelector('#im-sample-consent') : null;
  const sampleModalTitleNode = sampleModal ? sampleModal.querySelector('.im-modal__title') : null;
  const sampleModalDescriptionNode = sampleModal ? sampleModal.querySelector('.im-modal__description') : null;
  const sampleSummaryCollapsibles = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-summary-collapsible]'))
    : [];
  const sampleSummaryItemContainers = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-summary-items]'))
    : [];
  const sampleSubtotalNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-subtotal]'))
    : [];
  const sampleTotalTodayNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-total-today]'))
    : [];
  const sampleUnitPriceNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-unit-price]'))
    : [];
  const sampleCurrencyNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-currency]'))
    : [];
  const sampleQtyTotalNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-qty-total]'))
    : [];
  const sampleCountryField = sampleModal ? sampleModal.querySelector('[data-im-sample-country]') : null;
  const sampleRegionField = sampleModal ? sampleModal.querySelector('[data-im-sample-region]') : null;
  const sampleRegionLabel = sampleModal ? sampleModal.querySelector('[data-im-sample-region-label]') : null;
  const sampleSuccessEmailNodes = sampleModal
    ? Array.from(sampleModal.querySelectorAll('[data-im-sample-success-email]'))
    : [];
  const PRODUCT_CATALOG_LIMIT = 250;
  const PRODUCT_CATALOG_RESULTS_LIMIT = 40;
  const QUOTE_WIZARD_TOTAL_STEPS = 3;
  const SAMPLE_WIZARD_TOTAL_STEPS = 2;
  const QUOTE_DEFAULT_ITEM_QUANTITY = 100;
  const SAMPLE_MODAL_STEP_ONE_TITLE = sampleModalTitleNode
    ? String(sampleModalTitleNode.textContent || '').trim() || 'Order Samples'
    : 'Order Samples';
  const SAMPLE_MODAL_STEP_TWO_TITLE = 'Delivery details';
  const SAMPLE_DEFAULT_MAX_UNITS = 20;
  // Fallback prices in cents — only reached if modal-sample.liquid fails to set
  // data-im-sample-unit-price-{cur} on the modal. Keep these in sync with
  // unit_price_{eur,gbp,usd} in snippets/modal-sample.liquid so customers never
  // get charged a divergent amount.
  const SAMPLE_DEFAULT_UNIT_PRICE_CENTS = 1200; // EUR baseline
  const SAMPLE_ANY_VARIANT_LABEL = 'Any (closest match)';
  const SAMPLE_ANY_VARIANT_VALUE = '__any__';
  const SAMPLE_UNIT_PRICE_MAP = {
    EUR: 1200,
    USD: 1300,
    GBP: 1100,
  };
  const SAMPLE_REGION_REQUIRED_COUNTRIES = new Set([
    'us',
    'usa',
    'united-states',
    'united-states-of-america',
    'ca',
    'canada',
  ]);
  const SAMPLE_ELIGIBLE_TAG_TOKENS = new Set([
    'sample-eligible',
    'samples-eligible',
    'sample-available',
    'samples-available',
    'sample-order',
    'sample-ordering',
    'sample-yes',
  ]);
  const FORM_DEBUG_QUERY_PARAM = 'im_debug_forms';
  const FORM_SUCCESS_QUERY_PARAM = 'im_modal_success';
  const isFormDebugMode = (() => {
    let storedFlag = false;
    try {
      storedFlag = window.localStorage.getItem(FORM_DEBUG_QUERY_PARAM) === '1';
    } catch (error) {
      storedFlag = false;
    }
    let queryFlag = false;
    try {
      queryFlag = new URLSearchParams(window.location.search).get(FORM_DEBUG_QUERY_PARAM) === '1';
    } catch (error) {
      queryFlag = false;
    }
    if (queryFlag) {
      try {
        window.localStorage.setItem(FORM_DEBUG_QUERY_PARAM, '1');
      } catch (error) {
        // Ignore storage errors.
      }
    }
    return queryFlag || storedFlag || Boolean(window.Shopify && window.Shopify.designMode);
  })();

  const logSubmitDebug = (...args) => {
    if (!isFormDebugMode || !window.console || typeof window.console.log !== 'function') return;
    window.console.log('[IM Submit Debug]', ...args);
  };

  /* ── Quote product card pricing ── */
  const QUOTE_CURRENCY_SYMBOLS = { EUR: '€', GBP: '£', USD: '$' };

  const _quotePriceMap = (() => {
    const el = quoteModal && quoteModal.querySelector('[data-im-quote-price-map]');
    if (!el) return {};
    try { return JSON.parse('{' + el.textContent + '}'); } catch { return {}; }
  })();

  // The product page's Volume Pricing block is the source of truth. Read it from
  // the DOM when present so editing the tiers in the theme editor is enough; the
  // JSON in the modal is only the fallback for pages without the block.
  const _quoteVolumeTiers = (() => {
    const fromProductPage = Array.from(document.querySelectorAll('[data-im-tier-select][data-tier-threshold]'))
      .map((node) => ({
        threshold: parseInt(String(node.getAttribute('data-tier-threshold') || '').replace(/[^0-9]/g, ''), 10) || 0,
        discount: parseFloat(String(node.getAttribute('data-tier-discount') || '').replace(/[^0-9.]/g, '')) || 0,
        label: String(node.getAttribute('data-tier-label') || '').trim(),
      }))
      .filter((t) => t.threshold > 0 && t.discount > 0);

    if (fromProductPage.length) {
      const seen = new Set();
      return fromProductPage
        .filter((t) => (seen.has(t.threshold) ? false : seen.add(t.threshold)))
        .sort((a, b) => a.threshold - b.threshold);
    }

    const el = quoteModal && quoteModal.querySelector('[data-im-quote-volume-tiers]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent)
        .map(t => ({
          threshold: parseInt(String(t.qty).replace(/[^0-9]/g, ''), 10) || 0,
          discount: parseFloat(String(t.disc).replace(/[^0-9.]/g, '')) || 0,
          label: t.qty,
        }))
        .filter(t => t.threshold > 0)
        .sort((a, b) => a.threshold - b.threshold);
    } catch { return []; }
  })();

  const getQuoteCurrency = () => {
    const sw = document.querySelector('[data-im-price-switch][data-current-currency]');
    if (sw) {
      const c = String(sw.getAttribute('data-current-currency') || '').trim().toUpperCase();
      if (QUOTE_CURRENCY_SYMBOLS[c]) return c;
    }
    try {
      const raw = window.localStorage.getItem('im_currency');
      if (!raw) return 'EUR';
      const direct = String(raw || '').trim().toUpperCase();
      if (QUOTE_CURRENCY_SYMBOLS[direct]) return direct;
      const parsed = JSON.parse(raw);
      const cur = String(parsed && parsed.currency ? parsed.currency : '').trim().toUpperCase();
      return QUOTE_CURRENCY_SYMBOLS[cur] ? cur : 'EUR';
    } catch { return 'EUR'; }
  };

  const getQuotePriceForHandle = (handle) => {
    const entry = _quotePriceMap[handle];
    if (!entry) return 0;
    const cur = getQuoteCurrency().toLowerCase();
    const val = entry[cur];
    if (!val) return 0;
    if (typeof val === 'number') return val;
    if (typeof val === 'string') return parseFloat(val) || 0;
    if (typeof val === 'object' && val.amount != null) return parseFloat(val.amount) || 0;
    return parseFloat(val) || 0;
  };

  const formatCount = (value) =>
    String(Math.round(Number(value) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const ceilCents = (value) => {
    if (!Number.isFinite(value)) return 0;
    return Math.ceil(value * 100 - 1e-6) / 100;
  };

  const findQuoteVolumeTier = (qty) => {
    let best = null;
    for (const tier of _quoteVolumeTiers) {
      if (qty >= tier.threshold) best = tier;
    }
    return best;
  };

  const formatQuoteMoney = (amount, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch {
      const sym = QUOTE_CURRENCY_SYMBOLS[currency] || currency + ' ';
      return sym + amount.toFixed(2);
    }
  };

  const updateQuotePricingNode = (pricingEl, handle, quantity) => {
    if (!pricingEl) return;
    const base = getQuotePriceForHandle(handle);
    if (!base) { pricingEl.style.display = 'none'; return; }

    pricingEl.style.display = '';
    const currency = getQuoteCurrency();
    const sym = QUOTE_CURRENCY_SYMBOLS[currency] || '';
    const tier = findQuoteVolumeTier(quantity);
    const disc = tier ? tier.discount : 0;
    const unit = base * (1 - disc / 100);
    const total = unit * quantity;

    const unitLine = pricingEl.querySelector('[data-im-qp-unit]');
    if (unitLine) {
      if (disc > 0) {
        unitLine.innerHTML = '<s>' + sym + base.toFixed(2) + '</s> ' + sym + unit.toFixed(2) + '/unit · <span class="im-quote-products__pricing-discount">\u2013' + disc + '%</span>';
      } else {
        unitLine.textContent = sym + base.toFixed(2) + '/unit';
      }
    }

    const totalLine = pricingEl.querySelector('[data-im-qp-total]');
    if (totalLine) {
      totalLine.textContent = 'Est. total: ' + formatQuoteMoney(total, currency);
    }
  };

  const refreshAllQuotePricing = () => {
    if (!quoteProductsContainer) return;
    quoteProductsContainer.querySelectorAll('[data-im-quote-pricing]').forEach(el => {
      const handle = el.getAttribute('data-im-quote-pricing-handle') || '';
      const qtyInput = el.closest('.im-quote-products__item')?.querySelector('[data-im-quote-qty]');
      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 100;
      updateQuotePricingNode(el, handle, qty);
    });
  };

  const updateScrollHintState = (node) => {
    if (!node) return;
    const hasOverflow = node.scrollHeight - node.clientHeight > 6;
    const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 4;
    node.classList.toggle('is-scrollable', hasOverflow);
    node.classList.toggle('is-scroll-end', !hasOverflow || atBottom);
  };

  const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;
  const getSampleAddLabel = () => (isMobileViewport() ? 'ADD' : 'Add sample');
  const buildStepDotsLabel = (currentStep, totalSteps) => {
    const current = Number.isFinite(Number(currentStep)) ? Number(currentStep) : 1;
    const total = Number.isFinite(Number(totalSteps)) ? Number(totalSteps) : 1;
    const parts = [];
    for (let step = 1; step <= total; step += 1) {
      parts.push(`${step} ${step === current ? '●' : '○'}`);
    }
    return parts.join('   ');
  };

  const clearQuoteSearchResults = () => {
    if (!quoteSearchResults) return;
    quoteSearchResults.innerHTML = '';
    updateScrollHintState(quoteSearchResults);
  };

  const clearSampleSearchResults = () => {
    if (!sampleSearchResults) return;
    sampleSearchResults.innerHTML = '';
    updateScrollHintState(sampleSearchResults);
  };

  const lockBodyScroll = () => {
    if (document.body.dataset.imModalScrollLocked === 'true') return;
    const currentScrollTop = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.imModalScrollLocked = 'true';
    document.body.dataset.imModalScrollY = String(currentScrollTop);
    document.body.style.top = `-${currentScrollTop}px`;
  };

  const unlockBodyScroll = () => {
    if (document.body.dataset.imModalScrollLocked !== 'true') return;
    const storedOffset = Number(document.body.dataset.imModalScrollY || 0);
    document.body.dataset.imModalScrollLocked = '';
    document.body.dataset.imModalScrollY = '';
    document.body.style.top = '';
    if (Number.isFinite(storedOffset) && storedOffset > 0) {
      window.scrollTo(0, storedOffset);
    }
  };

  const bindScrollHint = (node) => {
    if (!node || node.dataset.imScrollHintBound === 'true') return;
    node.dataset.imScrollHintBound = 'true';
    node.addEventListener(
      'scroll',
      () => {
        updateScrollHintState(node);
      },
      { passive: true }
    );
    window.addEventListener(
      'resize',
      () => {
        updateScrollHintState(node);
      },
      { passive: true }
    );
    window.requestAnimationFrame(() => updateScrollHintState(node));
  };

  const revealListContainer = (container) => {
    if (!container) return;
    const scrollParent = container.closest('.im-modal__body') || container.closest('dialog');
    if (scrollParent) {
      const offset = container.offsetTop - scrollParent.offsetTop;
      scrollParent.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
    }
  };

  [quoteProductsContainer, quoteSearchResults, sampleSearchResults, sampleLinesContainer].forEach((node) => {
    bindScrollHint(node);
  });

  if (quoteForm) {
    quoteForm.noValidate = true;
    // Hard-stop native submits/reloads for quote form.
    quoteForm.addEventListener(
      'submit',
      (event) => {
        if (
          quoteForm.dataset.imAllowNativeSubmit === 'true' ||
          quoteForm.dataset.imCaptureCaptchaSubmit === 'true'
        ) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  const normalizeLabel = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const normalizeOptionName = (value) => normalizeLabel(value).replace(/\s+/g, ' ');
  const normalizeToken = (value) => normalizeLabel(value).replace(/\s+/g, '-');
  const getTagsList = (tagsValue) => {
    if (Array.isArray(tagsValue)) {
      return tagsValue.map((tag) => String(tag || '').trim()).filter(Boolean);
    }
    if (typeof tagsValue === 'string') {
      return tagsValue
        .split(',')
        .map((tag) => String(tag || '').trim())
        .filter(Boolean);
    }
    return [];
  };

  const toNumber = (value) => {
    if (value === '' || value === null || typeof value === 'undefined') return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const clampQuantity = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 1;
    return Math.min(99999, Math.max(1, Math.round(parsed)));
  };

  const buildSubmissionMeta = () => {
    const timestampUtc = new Date().toISOString();
    const compact = timestampUtc.replace(/[^0-9]/g, '').slice(0, 14);
    const randomToken = Math.random().toString(36).slice(2, 7).toUpperCase();
    return {
      id: `IM-${compact}-${randomToken}`,
      timestampUtc,
    };
  };

  const getShopifyRoot = () => {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const buildShopifyUrl = (path) => `${getShopifyRoot()}${String(path || '').replace(/^\/+/, '')}`;

  const productJsonNode = document.querySelector('[data-im-modal-product]');
  let productData = null;
  if (productJsonNode) {
    try {
      productData = JSON.parse(productJsonNode.textContent || '{}');
    } catch (error) {
      productData = null;
    }
  }

  const normalizeImageSrc = (value) => {
    if (!value) return '';
    const src = String(value).trim();
    if (!src) return '';
    if (src.startsWith('//')) return `${window.location.protocol}${src}`;
    return src;
  };

  const extractImageSrc = (imageValue) => {
    if (!imageValue) return '';
    if (typeof imageValue === 'string') return normalizeImageSrc(imageValue);
    if (typeof imageValue === 'object') {
      return normalizeImageSrc(
        imageValue.src ||
        imageValue.url ||
        imageValue.preview_image?.src ||
        imageValue.preview_image?.url ||
        imageValue.originalSrc ||
        ''
      );
    }
    return '';
  };

  const variantMap = new Map();
  if (productData && Array.isArray(productData.variants)) {
    productData.variants.forEach((variant) => {
      const variantId = toNumber(variant && variant.id);
      if (variantId !== null) variantMap.set(variantId, variant);
    });
  }

  const state = {
    productId: toNumber(productData && productData.id),
    productTitle: (productData && productData.title) || '',
    productHandle: (productData && productData.handle) || '',
    productImage: extractImageSrc(productData && productData.featured_image),
    variantImages: (productData && productData.variant_images) || {},
    estimatedQuantity: null,
    variant: null,
    quoteItems: [],
    quoteWizardStep: 1,
    locationAttempted: false,
    quoteSelectorContext: new Map(),
    quoteStatusTimer: null,
    sampleItems: [],
    sampleWizardStep: 1,
    sampleStatusTimer: null,
    sampleLineCounter: 0,
  };

  const quoteProductDetailsCache = new Map();
  const quoteVariantOptionsCache = new Map();
  let quoteSearchTimer = null;
  let quoteSearchRequestId = 0;
  let quoteSearchAutoLoaded = false;
  let quoteCatalogProducts = [];
  let quoteCatalogLoaded = false;
  let quoteCatalogLoading = false;
  let sampleSearchTimer = null;
  let sampleSearchRequestId = 0;
  let sampleSearchAutoLoaded = false;

  const getVariantById = (id) => {
    const numericId = toNumber(id);
    if (numericId === null) return null;
    return variantMap.get(numericId) || null;
  };

  const getVariantImage = (variant) => {
    if (!variant) return '';
    const mappedVariantImage =
      (variant.id && state.variantImages && state.variantImages[String(variant.id)]) || '';
    return (
      extractImageSrc(mappedVariantImage) ||
      extractImageSrc(variant.featured_image) ||
      extractImageSrc(variant.featured_media) ||
      extractImageSrc(variant.image) ||
      state.productImage ||
      ''
    );
  };

  const normalizeVariantTitle = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const normalized = raw.toLowerCase();
    if (normalized === 'default title' || normalized === 'default') return '';
    return raw;
  };

  const truncateText = (value, maxLength = 40) => {
    const text = String(value || '').trim();
    if (!text) return '';
    if (!Number.isFinite(maxLength) || maxLength < 6 || text.length <= maxLength) return text;
    return `${text.slice(0, maxLength - 3).trimEnd()}...`;
  };

  const COLOR_SWATCH_HINTS = [
    ['light pink', '#f8bbd0'],
    ['pink', '#ec4899'],
    ['rose', '#f43f5e'],
    ['red', '#e53935'],
    ['orange', '#fb8c00'],
    ['amber', '#f59e0b'],
    ['yellow', '#fdd835'],
    ['lime', '#84cc16'],
    ['green', '#22c55e'],
    ['mint', '#34d399'],
    ['teal', '#14b8a6'],
    ['cyan', '#06b6d4'],
    ['turquoise', '#06b6b7'],
    ['aqua', '#22d3ee'],
    ['sky blue', '#38bdf8'],
    ['ice blue', '#7dd3fc'],
    ['blue', '#3b82f6'],
    ['navy', '#1e3a8a'],
    ['indigo', '#4f46e5'],
    ['violet', '#8b5cf6'],
    ['purple', '#a855f7'],
    ['magenta', '#d946ef'],
    ['brown', '#8d6e63'],
    ['beige', '#d6c2a6'],
    ['ivory', '#f8f5e9'],
    ['white', '#f9fafb'],
    ['grey', '#9ca3af'],
    ['gray', '#9ca3af'],
    ['silver', '#c0c0c0'],
    ['charcoal', '#374151'],
    ['black', '#111827'],
    ['clear', '#e5eef7'],
  ];

  const getColorSwatchHex = (value) => {
    const rawValue = String(value || '').trim().toLowerCase();
    if (!rawValue) return '';

    const hexMatch = rawValue.match(/#([0-9a-f]{3}|[0-9a-f]{6})\b/i);
    if (hexMatch) return `#${hexMatch[1]}`;

    for (let index = 0; index < COLOR_SWATCH_HINTS.length; index += 1) {
      const [token, hex] = COLOR_SWATCH_HINTS[index];
      if (rawValue.includes(token)) return hex;
    }
    return '';
  };

  const getProductOptionNames = (options) => {
    if (!Array.isArray(options)) return [];
    return options.map((option) => {
      if (typeof option === 'string') return normalizeOptionName(option);
      if (option && typeof option === 'object') return normalizeOptionName(option.name);
      return '';
    });
  };

  const extractVariantColorLabel = (variant, optionNames = []) => {
    if (!variant || typeof variant !== 'object') return '';
    const normalizedOptionNames = Array.isArray(optionNames) ? optionNames : [];
    const optionKeys = ['option1', 'option2', 'option3'];

    for (let index = 0; index < optionKeys.length; index += 1) {
      const optionName = normalizedOptionNames[index] || '';
      if (!optionName.includes('color') && !optionName.includes('colour')) continue;
      const colorValue = normalizeVariantTitle(variant[optionKeys[index]]);
      if (colorValue) return colorValue;
    }

    return normalizeVariantTitle(variant.title || '');
  };

  const buildVariantOptions = (variants, fallbackImage, imageLookup, optionNames) => {
    if (!Array.isArray(variants)) return [];
    const normalizedOptionNames = getProductOptionNames(optionNames);

    const options = variants
      .map((variant) => {
        const id = toNumber(variant && variant.id);
        if (id === null) return null;
        const optionValues = ['option1', 'option2', 'option3']
          .map((key) => normalizeVariantTitle(variant && variant[key]))
          .filter(Boolean);
        const imageFromMap = imageLookup && imageLookup[String(id)] ? imageLookup[String(id)] : '';
        const image = extractImageSrc(
          imageFromMap ||
            (variant &&
              (variant.featured_image ||
                variant.featured_media ||
                variant.image ||
                variant.preview_image)) ||
            fallbackImage
        );
        const title = normalizeVariantTitle(variant && variant.title) || 'Default';
        const colorLabel = extractVariantColorLabel(variant, normalizedOptionNames);
        const variantSearchText = normalizeLabel(
          `${title} ${colorLabel} ${optionValues.join(' ')} ${variant && variant.sku ? variant.sku : ''}`
        );
        return {
          id,
          title,
          colorLabel,
          optionValues,
          searchText: variantSearchText,
          available: !(variant && variant.available === false),
          image,
        };
      })
      .filter(Boolean);

    return options;
  };

  const setVariantOptionsForHandle = (handle, options) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle || !Array.isArray(options) || !options.length) return;
    quoteVariantOptionsCache.set(normalizedHandle, options);
  };

  const getVariantOptionsForHandle = (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return [];
    const options = quoteVariantOptionsCache.get(normalizedHandle);
    return Array.isArray(options) ? options : [];
  };

  const setQuoteSelectorVariant = (handle, variantId) => {
    const normalizedHandle = String(handle || '').trim();
    const normalizedVariantId = toNumber(variantId);
    if (!normalizedHandle || normalizedVariantId === null) return;
    state.quoteSelectorContext.set(normalizedHandle, normalizedVariantId);
  };

  const getQuoteSelectorVariant = (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;
    return toNumber(state.quoteSelectorContext.get(normalizedHandle));
  };

  const showQuoteStatus = (message, type = 'info') => {
    if (!quoteStatusRegion) return;
    if (state.quoteStatusTimer) {
      window.clearTimeout(state.quoteStatusTimer);
      state.quoteStatusTimer = null;
    }

    const safeMessage = String(message || '').trim();
    if (!safeMessage) {
      quoteStatusRegion.textContent = '';
      quoteStatusRegion.removeAttribute('data-state');
      quoteStatusRegion.classList.remove('is-visible');
      return;
    }

    quoteStatusRegion.textContent = safeMessage;
    quoteStatusRegion.setAttribute('data-state', type);
    quoteStatusRegion.classList.add('is-visible');
    state.quoteStatusTimer = window.setTimeout(() => {
      quoteStatusRegion.textContent = '';
      quoteStatusRegion.removeAttribute('data-state');
      quoteStatusRegion.classList.remove('is-visible');
      state.quoteStatusTimer = null;
    }, 3200);
  };

  const getSampleMaxUnits = () => {
    const configuredMax = toNumber(sampleModal && sampleModal.getAttribute('data-im-sample-max-units'));
    if (configuredMax === null) return SAMPLE_DEFAULT_MAX_UNITS;
    return Math.max(1, Math.round(configuredMax));
  };

  const getStoredPriceSwitchCurrency = () => {
    try {
      const raw = window.localStorage.getItem('im_currency');
      if (!raw) return '';
      const direct = String(raw || '').trim().toUpperCase();
      if (SAMPLE_UNIT_PRICE_MAP[direct]) return direct;

      const parsed = JSON.parse(raw);
      const currency = String(parsed && parsed.currency ? parsed.currency : '').trim().toUpperCase();
      if (SAMPLE_UNIT_PRICE_MAP[currency]) return currency;
      return '';
    } catch (error) {
      return '';
    }
  };

  const getPriceSwitchCurrencyFromDom = () => {
    const activeSwitch = document.querySelector('[data-im-price-switch][data-current-currency]');
    if (activeSwitch) {
      const current = String(activeSwitch.getAttribute('data-current-currency') || '').trim().toUpperCase();
      if (SAMPLE_UNIT_PRICE_MAP[current]) return current;
    }

    const activeButton = document.querySelector('[data-im-price-switch] [data-im-currency-btn].is-active');
    if (!activeButton) return '';
    const code = String(activeButton.getAttribute('data-im-currency-btn') || '').trim().toUpperCase();
    return SAMPLE_UNIT_PRICE_MAP[code] ? code : '';
  };

  const getSampleCurrency = () => {
    const switchedCurrency = getPriceSwitchCurrencyFromDom() || getStoredPriceSwitchCurrency();
    const activeCurrency =
      window.Shopify &&
      window.Shopify.currency &&
      typeof window.Shopify.currency.active === 'string'
        ? window.Shopify.currency.active
        : '';
    const fallbackCurrency = sampleModal ? sampleModal.getAttribute('data-im-sample-default-currency') : '';
    const normalized = String(switchedCurrency || activeCurrency || fallbackCurrency || '').trim().toUpperCase();
    return normalized || 'EUR';
  };

  const getSampleUnitPriceCents = () => {
    const currency = getSampleCurrency();
    const configuredMapValue =
      sampleModal && sampleModal.hasAttribute(`data-im-sample-unit-price-${currency.toLowerCase()}`)
        ? toNumber(sampleModal.getAttribute(`data-im-sample-unit-price-${currency.toLowerCase()}`))
        : null;
    if (configuredMapValue !== null && configuredMapValue >= 0) {
      return Math.round(configuredMapValue);
    }
    return SAMPLE_UNIT_PRICE_MAP[currency] || SAMPLE_DEFAULT_UNIT_PRICE_CENTS;
  };

  const formatSampleMoney = (centsValue) => {
    const cents = Math.round(Number(centsValue) || 0);
    const currency = getSampleCurrency();
    const expectedCurrencyHints = {
      EUR: ['€', 'eur'],
      USD: ['$', 'usd'],
      GBP: ['£', 'gbp'],
    };
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const formatted = String(window.Shopify.formatMoney(cents, window.Shopify.money_format) || '');
        const hints = expectedCurrencyHints[currency] || [];
        if (!hints.length) return formatted;
        const normalizedFormatted = formatted.toLowerCase();
        const isLikelyCorrectCurrency = hints.some((hint) =>
          hint === '$' ? formatted.includes('$') : normalizedFormatted.includes(hint)
        );
        if (isLikelyCorrectCurrency) {
          return formatted;
        }
      } catch (error) {
        // Fallback below.
      }
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return `${currency} ${(cents / 100).toFixed(2)}`;
    }
  };

  const clampSampleQuantity = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 1;
    return Math.max(1, Math.round(parsed));
  };

  const getSampleTotalUnits = () =>
    state.sampleItems.reduce((sum, item) => sum + clampSampleQuantity(item && item.quantity), 0);

  const getSampleSubtotalCents = () => getSampleTotalUnits() * getSampleUnitPriceCents();

  const getSampleVariantOptionsForHandle = (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return [];
    return getVariantOptionsForHandle(normalizedHandle).filter((option) => {
      const title = normalizeVariantTitle(option && option.title ? option.title : '');
      return !!title;
    });
  };

  const getSampleVariantForHandle = (handle, variantId) => {
    const normalizedVariantId = toNumber(variantId);
    if (normalizedVariantId === null) return null;
    const options = getSampleVariantOptionsForHandle(handle);
    return options.find((option) => option.id === normalizedVariantId) || null;
  };

  const getSampleVariantChoiceCount = (handle) =>
    Array.from(
      new Set(
        getSampleVariantOptionsForHandle(handle)
          .map((option) => normalizeVariantTitle(option && option.title ? option.title : ''))
          .filter(Boolean)
      )
    ).length;

  const hasSampleVariantChoices = (handle) => getSampleVariantChoiceCount(handle) > 1;

  const getSampleItemImage = (item) => {
    if (!item) return '';
    const selectedVariant = getSampleVariantForHandle(item.productHandle, item.variantId);
    if (selectedVariant && selectedVariant.image) return selectedVariant.image;
    return extractImageSrc(item.productImage || item.image || '');
  };

  const nextSampleLineId = () => {
    state.sampleLineCounter += 1;
    return `sample-${state.sampleLineCounter}`;
  };

  const getSampleItemKey = (item) => {
    if (!item) return '';
    const handle = String(item.productHandle || '').trim() || toHandleFallback(item.productTitle || '');
    const variantToken = toNumber(item.variantId);
    if (variantToken === null) return `${handle}|any`;
    return `${handle}|${variantToken}`;
  };

  const isSampleEligibleProduct = (product) => {
    const tags = getTagsList(product && product.tags);
    if (!tags.length) return false;
    return tags.some((tag) => SAMPLE_ELIGIBLE_TAG_TOKENS.has(normalizeToken(tag)));
  };

  const getSampleEligibleCatalogProducts = () => {
    if (!quoteCatalogProducts.length) return [];
    const eligible = quoteCatalogProducts.filter((item) => item && item.sampleEligible);
    if (eligible.length) return eligible;
    return quoteCatalogProducts;
  };

  const isSampleEligibilityFallback = () => {
    if (!quoteCatalogProducts.length) return false;
    return !quoteCatalogProducts.some((item) => item && item.sampleEligible);
  };

  const showSampleStatus = (message, type = 'info') => {
    if (!sampleStatusRegion) return;
    if (state.sampleStatusTimer) {
      window.clearTimeout(state.sampleStatusTimer);
      state.sampleStatusTimer = null;
    }

    const safeMessage = String(message || '').trim();
    if (!safeMessage) {
      sampleStatusRegion.textContent = '';
      sampleStatusRegion.removeAttribute('data-state');
      sampleStatusRegion.classList.remove('is-visible');
      return;
    }

    sampleStatusRegion.textContent = safeMessage;
    sampleStatusRegion.setAttribute('data-state', type);
    sampleStatusRegion.classList.add('is-visible');
    state.sampleStatusTimer = window.setTimeout(() => {
      sampleStatusRegion.textContent = '';
      sampleStatusRegion.removeAttribute('data-state');
      sampleStatusRegion.classList.remove('is-visible');
      state.sampleStatusTimer = null;
    }, 3200);
  };

  if (state.productHandle && Array.isArray(productData && productData.variants)) {
    setVariantOptionsForHandle(
      state.productHandle,
      buildVariantOptions(productData.variants, state.productImage, state.variantImages, productData && productData.options)
    );
  }

  const toHandleFallback = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const getNormalizedVariantId = (value) => {
    const numeric = toNumber(value);
    return numeric === null ? null : numeric;
  };

  const quoteItemKey = (item) => {
    if (!item) return '';
    const variantId = getNormalizedVariantId(item.variantId || item.variant_id);
    if (variantId !== null) return `variant:${variantId}`;
    const baseHandle = item.productHandle || item.product_handle || toHandleFallback(item.productTitle || item.product_title);
    const variantToken = normalizeLabel(item.variantTitle || item.variant_title || 'default').replace(/\s+/g, '-');
    return `product:${baseHandle || 'item'}|${variantToken || 'default'}`;
  };

  const quoteItemDomKey = (item) =>
    quoteItemKey(item).replace(/[^a-zA-Z0-9_-]+/g, '-');

  const sanitizeQuoteItem = (rawItem) => {
    if (!rawItem || typeof rawItem !== 'object') return null;
    const rawHandle = String(rawItem.productHandle || rawItem.product_handle || state.productHandle || '').trim();
    const rawTitle = String(rawItem.productTitle || rawItem.product_title || state.productTitle || '').trim();
    const rawProductId = toNumber(rawItem.productId || rawItem.product_id || state.productId);
    const rawVariantId = toNumber(rawItem.variantId || rawItem.variant_id);
    const rawVariantTitle = normalizeVariantTitle(rawItem.variantTitle || rawItem.variant_title || '');
    const itemProductHandle = rawHandle || toHandleFallback(rawTitle);
    const item = {
      productId: rawProductId,
      productHandle: itemProductHandle,
      productTitle: rawTitle,
      variantId: rawVariantId,
      variantTitle: rawVariantTitle || 'Default',
      image: extractImageSrc(
        rawItem.image ||
          rawItem.image_src ||
          (itemProductHandle && itemProductHandle === state.productHandle ? state.productImage : '')
      ),
      quantity: clampQuantity(
        typeof rawItem.quantity === 'undefined' ? QUOTE_DEFAULT_ITEM_QUANTITY : rawItem.quantity
      ),
    };

    if (!item.productTitle && !item.variantTitle) return null;
    if (item.variantId === null && item.variantTitle === 'Default') return null;
    return item;
  };

  const loadQuoteItems = () => {
    try {
      const raw = window.localStorage.getItem(QUOTE_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item) => sanitizeQuoteItem(item))
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  };

  const saveQuoteItems = () => {
    try {
      window.localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(state.quoteItems));
    } catch (error) {
      // Ignore storage failures.
    }
  };

  const getQuoteDraftFields = () => {
    if (!quoteForm) return [];
    return Array.from(quoteForm.querySelectorAll('[data-im-field]')).filter(
      (field) => field && field.name && field.type !== 'file'
    );
  };

  const loadQuoteDraft = () => {
    try {
      const raw = window.localStorage.getItem(QUOTE_DRAFT_STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  const saveQuoteDraft = () => {
    if (!quoteForm) return;
    try {
      const draft = {
        step: state.quoteWizardStep,
        fields: {},
      };

      getQuoteDraftFields().forEach((field) => {
        const key = String(field.getAttribute('data-im-field') || '').trim();
        if (!key) return;

        if (field.type === 'checkbox') {
          draft.fields[key] = field.checked ? '1' : '0';
          return;
        }

        if (field.type === 'radio') {
          if (field.checked) draft.fields[key] = String(field.value || '');
          return;
        }

        draft.fields[key] = String(field.value || '');
      });

      window.localStorage.setItem(QUOTE_DRAFT_STORAGE_KEY, JSON.stringify(draft));
    } catch (error) {
      // Ignore storage failures.
    }
  };

  const applyQuoteDraft = () => {
    if (!quoteForm) return;
    const draft = loadQuoteDraft();
    if (!draft) return;

    const savedFields = draft.fields && typeof draft.fields === 'object' ? draft.fields : {};
    getQuoteDraftFields().forEach((field) => {
      const key = String(field.getAttribute('data-im-field') || '').trim();
      if (!key || !Object.prototype.hasOwnProperty.call(savedFields, key)) return;
      const value = savedFields[key];

      if (field.type === 'checkbox') {
        field.checked = value === '1' || value === true || value === 'true';
        return;
      }

      if (field.type === 'radio') {
        field.checked = String(field.value || '') === String(value || '');
        return;
      }

      field.value = String(value || '');
    });

    const draftStep = Number(draft.step);
    if (Number.isFinite(draftStep)) {
      state.quoteWizardStep = Math.max(1, Math.min(QUOTE_WIZARD_TOTAL_STEPS, Math.round(draftStep)));
    }
  };

  const clearQuoteDraft = () => {
    try {
      window.localStorage.removeItem(QUOTE_DRAFT_STORAGE_KEY);
    } catch (error) {
      // Ignore storage failures.
    }
  };

  const loadQuoteEmailHistory = () => {
    try {
      const raw = window.localStorage.getItem(QUOTE_EMAIL_HISTORY_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((email) => String(email || '').trim().toLowerCase())
        .filter((email) => email.includes('@'));
    } catch (error) {
      return [];
    }
  };

  const saveQuoteEmailHistory = (emails) => {
    try {
      window.localStorage.setItem(
        QUOTE_EMAIL_HISTORY_STORAGE_KEY,
        JSON.stringify(
          Array.isArray(emails)
            ? emails.slice(0, QUOTE_EMAIL_HISTORY_LIMIT).map((email) => String(email || '').trim().toLowerCase())
            : []
        )
      );
    } catch (error) {
      // Ignore storage failures.
    }
  };

  const renderQuoteEmailSuggestions = () => {
    if (!quoteEmailSuggestions) return;
    quoteEmailSuggestions.innerHTML = '';
    loadQuoteEmailHistory().forEach((email) => {
      const option = document.createElement('option');
      option.value = email;
      quoteEmailSuggestions.appendChild(option);
    });
  };

  const rememberQuoteEmail = (emailValue) => {
    const normalizedEmail = String(emailValue || '').trim().toLowerCase();
    if (!normalizedEmail || !normalizedEmail.includes('@')) return;
    const currentHistory = loadQuoteEmailHistory();
    const nextHistory = [normalizedEmail, ...currentHistory.filter((item) => item !== normalizedEmail)].slice(
      0,
      QUOTE_EMAIL_HISTORY_LIMIT
    );
    saveQuoteEmailHistory(nextHistory);
    renderQuoteEmailSuggestions();
  };

  const readVariantFromDom = () => {
    const applyVariantToState = (variant) => {
      if (!variant || !variant.id) return false;
      state.variant = variant;
      if (state.productHandle) {
        setQuoteSelectorVariant(state.productHandle, variant.id);
      }
      return true;
    };

    const selectedVariantNode = document.querySelector('variant-selects [data-selected-variant]');
    if (selectedVariantNode) {
      try {
        const variant = JSON.parse(selectedVariantNode.textContent || '{}');
        if (applyVariantToState(variant)) {
          return;
        }
      } catch (error) {
        // no-op
      }
    }

    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    const variantFromInput = idInput ? getVariantById(idInput.value) : null;
    if (applyVariantToState(variantFromInput)) {
      return;
    }

    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    const variantFromUrl = getVariantById(urlVariant);
    if (applyVariantToState(variantFromUrl)) {
      return;
    }

    const defaultVariant = getVariantById(productData && productData.selected_variant_id);
    applyVariantToState(defaultVariant);
  };

  const parseCalculatorQuantity = () => {
    const liveState = window.IMCalculatorState;
    if (liveState && Number.isFinite(liveState.quantity)) {
      return clampQuantity(liveState.quantity);
    }

    const quantityNode = document.querySelector('[data-im-calc-quantity]');
    if (!quantityNode) return null;
    const normalized = String(quantityNode.textContent || '').replace(/[^0-9.]/g, '');
    const quantity = Number(normalized);
    if (!Number.isFinite(quantity) || quantity <= 0) return null;
    return clampQuantity(quantity);
  };

  const buildTags = (baseTag) => {
    const tags = [baseTag];
    if (baseTag === 'project_inquiry') tags.push('quote');
    if (baseTag === 'sample_request') tags.push('sample');
    return tags.join(',');
  };

  const sanitizeLeadTagToken = (value) => normalizeToken(value).replace(/^-+|-+$/g, '');

  const normalizeLeadColor = (value) => {
    const normalizedValue = normalizeVariantTitle(value || '');
    if (!normalizedValue) return '';
    const token = sanitizeLeadTagToken(normalizedValue);
    const anyToken = sanitizeLeadTagToken(SAMPLE_ANY_VARIANT_LABEL);
    if (!token || token === anyToken || token === 'any' || token.startsWith('any-closest')) {
      return '';
    }
    return normalizedValue;
  };

  const imBuildLeadTags = (data) => {
    const tags = ['source:product-page', 'status:new-lead'];

    if (data && data.type === 'quote') {
      tags.push('lead:quote');
    } else if (data && data.type === 'sample') {
      tags.push('lead:sample');
    }

    if (data && data.productHandle) {
      const token = sanitizeLeadTagToken(data.productHandle);
      if (token) tags.push(`product:${token}`);
    }

    if (data && data.color) {
      const token = sanitizeLeadTagToken(String(data.color || '').toLowerCase());
      if (token) tags.push(`color:${token}`);
    }

    if (data && data.projectType && data.type === 'quote') {
      const token = sanitizeLeadTagToken(String(data.projectType || '').toLowerCase());
      if (token) tags.push(`project_type:${token}`);
    }

    if (data && data.timeline && data.type === 'quote') {
      const token = sanitizeLeadTagToken(String(data.timeline || '').toLowerCase());
      if (token) tags.push(`timeline:${token}`);
    }

    return tags.join(', ');
  };

  const buildQuoteLeadData = (form) => {
    if (!form || !form.closest('[data-im-modal="quote"]')) return null;
    const quotePrimaryItem = state.quoteItems[0] || null;
    const quoteColor = normalizeLeadColor(
      (quotePrimaryItem && quotePrimaryItem.variantTitle) || (state.variant && state.variant.title)
    );

    const email = getFieldValue(form.querySelector('[data-im-field="email"]'));
    if (!email) return null;

    return {
      type: 'quote',
      email,
      firstName: getFieldValue(form.querySelector('[data-im-field="first_name"]')),
      lastName: getFieldValue(form.querySelector('[data-im-field="last_name"]')),
      marketingConsent: Boolean(quoteConsentField && quoteConsentField.checked),
      productHandle:
        (quotePrimaryItem && quotePrimaryItem.productHandle) ||
        state.productHandle ||
        '',
      texture: '',
      color: quoteColor,
      format: '',
      country: getFieldValue(form.querySelector('[data-im-field="country"]')),
      projectType: getFieldValue(form.querySelector('[data-im-field="project_type"]')),
      timeline: getFieldValue(form.querySelector('[data-im-field="timeline"]')),
    };
  };

  const buildSampleLeadData = (form) => {
    if (!form || !form.closest('[data-im-modal="sample"]')) return null;
    const samplePrimaryItem = state.sampleItems[0] || null;
    const sampleColor = normalizeLeadColor(samplePrimaryItem && samplePrimaryItem.variantTitle);

    const email = getFieldValue(form.querySelector('[data-im-field="email"]'));
    if (!email) return null;

    return {
      type: 'sample',
      email,
      firstName: getFieldValue(form.querySelector('[data-im-field="first_name"]')),
      lastName: getFieldValue(form.querySelector('[data-im-field="last_name"]')),
      marketingConsent: Boolean(sampleConsentField && sampleConsentField.checked),
      productHandle:
        (samplePrimaryItem && samplePrimaryItem.productHandle) ||
        state.productHandle ||
        '',
      texture: '',
      color: sampleColor,
      format: '',
      country: getFieldValue(form.querySelector('[data-im-field="country"]')),
    };
  };

  const buildLeadDataForModal = (modal, form) => {
    if (modal === quoteModal) return buildQuoteLeadData(form);
    if (modal === sampleModal) return buildSampleLeadData(form);
    return null;
  };

  const splitLeadTags = (value) =>
    String(value || '')
      .split(',')
      .map((tag) => String(tag || '').trim())
      .filter(Boolean);

  const mergeLeadTags = (...groups) => {
    const merged = [];
    const seen = new Set();
    groups.forEach((group) => {
      (Array.isArray(group) ? group : []).forEach((tag) => {
        const normalized = String(tag || '').trim();
        if (!normalized) return;
        const key = normalized.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        merged.push(normalized);
      });
    });
    return merged;
  };

  const getCalculatorContext = () => {
    const calculatorState = window.IMCalculatorState || {};
    const orientationNode = document.querySelector('[data-im-calc-orientation].is-active');
    const sizeNode = document.querySelector('[data-im-calc-size]');

    const widthMeters = Number(calculatorState.widthMeters);
    const heightMeters = Number(calculatorState.heightMeters);
    const area = Number(calculatorState.area);
    const quantity = Number(calculatorState.quantity);
    const quantityWithBuffer = Number(calculatorState.quantityWithBuffer);

    return {
      orientation: String(
        (orientationNode && orientationNode.getAttribute('data-im-calc-orientation')) || ''
      ).trim(),
      wallWidth: Number.isFinite(widthMeters) ? widthMeters : null,
      wallHeight: Number.isFinite(heightMeters) ? heightMeters : null,
      area: Number.isFinite(area) ? area : null,
      brickSize: String((sizeNode && sizeNode.value) || '').trim(),
      quantity: Number.isFinite(quantity) ? Math.round(quantity) : null,
      quantityWithBuffer: Number.isFinite(quantityWithBuffer) ? Math.round(quantityWithBuffer) : null,
    };
  };

  const buildLeadUpsertNote = (modal, form) => {
    const noteLines = [];
    const baseBody = buildStructuredBody(form);
    if (baseBody) {
      noteLines.push(baseBody);
    }

    const calculator = getCalculatorContext();
    const calculatorRows = [];
    if (calculator.orientation) calculatorRows.push(`Orientation: ${calculator.orientation}`);
    if (calculator.wallWidth !== null) calculatorRows.push(`Wall width: ${calculator.wallWidth.toFixed(2)} m`);
    if (calculator.wallHeight !== null) calculatorRows.push(`Wall height: ${calculator.wallHeight.toFixed(2)} m`);
    if (calculator.area !== null) calculatorRows.push(`Area m2: ${calculator.area.toFixed(2)} (+5% buffer)`);
    if (calculator.brickSize) calculatorRows.push(`Brick size: ${calculator.brickSize.replace(/x/g, '×')}`);
    if (calculator.quantity !== null) calculatorRows.push(`Calculated quantity: ${calculator.quantity}`);
    if (calculator.quantityWithBuffer !== null)
      calculatorRows.push(`Calculated quantity (+5%): ${calculator.quantityWithBuffer}`);

    const colorSet = new Set();
    if (modal === quoteModal) {
      state.quoteItems.forEach((item) => {
        const color = normalizeVariantTitle(item && item.variantTitle ? item.variantTitle : '');
        if (!color || color === SAMPLE_ANY_VARIANT_LABEL) return;
        colorSet.add(color);
      });
    } else if (modal === sampleModal) {
      state.sampleItems.forEach((item) => {
        const color = normalizeVariantTitle(item && item.variantTitle ? item.variantTitle : '');
        if (!color || color === SAMPLE_ANY_VARIANT_LABEL) return;
        colorSet.add(color);
      });
    }
    if (colorSet.size) {
      calculatorRows.push(`Selected variant/color(s): ${Array.from(colorSet).join(', ')}`);
    }

    if (calculatorRows.length) {
      if (noteLines.length) noteLines.push('');
      noteLines.push('Calculator Context');
      calculatorRows.forEach((row) => noteLines.push(row));
    }

    return noteLines.join('\n').trim();
  };

  const buildLeadUpsertPayload = (modal, form, flow, leadData) => {
    const calculator = getCalculatorContext();
    const sourceTag =
      flow === 'quote' && calculator.quantity !== null && calculator.quantity > 0
        ? 'source:calculator'
        : 'source:inquiry';
    const mergedTags = mergeLeadTags(['im-lead', sourceTag], splitLeadTags(imBuildLeadTags(leadData)));
    const sanitizeLeadPhone = (value) => {
      const raw = String(value || '').trim();
      if (!raw || raw.includes('@')) return '';
      const digits = raw.replace(/[^0-9]/g, '');
      if (digits.length < 6 || digits.length > 20) return '';
      return raw.replace(/[^0-9+\-().\s]/g, '').trim();
    };
    const phone = sanitizeLeadPhone(getFieldValue(form.querySelector('[data-im-field="phone"]')));

    return {
      email: String(leadData && leadData.email ? leadData.email : '')
        .trim()
        .toLowerCase(),
      first_name: String(leadData && leadData.firstName ? leadData.firstName : '').trim(),
      last_name: String(leadData && leadData.lastName ? leadData.lastName : '').trim(),
      phone: String(phone || '').trim(),
      tags: mergedTags.join(','),
      note: buildLeadUpsertNote(modal, form).slice(0, 6000),
      consent: Boolean(leadData && leadData.marketingConsent),
    };
  };

  const upsertLead = async (payload) => {
    const endpoint = '/apps/im-lead-upsert/upsert';
    const debugRecord = {
      endpoint,
      method: 'POST',
      mode: 'lead-upsert-proxy',
      payload: sanitizeDebugPayload(new URLSearchParams(payload || {})),
      status: 'pending',
      statusText: '',
      requestId: '',
      responseUrl: '',
      responseBody: '',
    };
    window.__IM_LAST_LEAD_UPSERT_DEBUG = debugRecord;
    logSubmitDebug('Lead upsert start', debugRecord);

    const response = await fetch(endpoint, {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();
    const requestId = String(response.headers.get('x-request-id') || '').trim();
    let responseJson = null;
    try {
      responseJson = JSON.parse(responseText);
    } catch (error) {
      responseJson = null;
    }

    const debugDone = {
      ...debugRecord,
      status: response.status,
      statusText: response.statusText || '',
      requestId,
      responseUrl: response.url || '',
      responseBody: String(responseText || '').slice(0, 1200),
    };
    window.__IM_LAST_LEAD_UPSERT_DEBUG = debugDone;
    logSubmitDebug('Lead upsert result', debugDone);

    if (!response.ok) {
      const detail =
        responseJson && (responseJson.detail || responseJson.error)
          ? String(responseJson.detail || responseJson.error)
          : `Lead upsert failed (${response.status}).`;
      throw createSubmitError(detail, {
        status: response.status,
        statusText: response.statusText || '',
        requestId,
      });
    }

    if (!responseJson || responseJson.ok !== true) {
      throw createSubmitError(
        (responseJson && (responseJson.detail || responseJson.error)) || 'Lead upsert returned an unexpected response.'
      );
    }

    return responseJson;
  };

  const submitLeadUpsertForModal = async (modal, form, flow, leadData) => {
    if (!leadData || !leadData.marketingConsent) {
      return { ok: true, skipped: 'consent_unchecked' };
    }
    const payload = buildLeadUpsertPayload(modal, form, flow, leadData);
    if (!payload.email) {
      return { ok: true, skipped: 'missing_email' };
    }
    return upsertLead(payload);
  };

  const postDraftOrder = async (config, payload) => {
    const { endpoint, mode, label, debugKey } = config;
    const debugRecord = {
      endpoint,
      method: 'POST',
      mode,
      payload: sanitizeDebugPayload(new URLSearchParams({ submission_id: String((payload && payload.submission_id) || '') })),
      status: 'pending',
      statusText: '',
      requestId: '',
      responseUrl: '',
      responseBody: '',
    };
    window[debugKey] = debugRecord;
    logSubmitDebug(`${label} start`, debugRecord);

    const response = await fetch(endpoint, {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-store',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();
    const requestId = String(response.headers.get('x-request-id') || '').trim();
    let responseJson = null;
    try {
      responseJson = JSON.parse(responseText);
    } catch (error) {
      responseJson = null;
    }

    const debugDone = {
      ...debugRecord,
      status: response.status,
      statusText: response.statusText || '',
      requestId,
      responseUrl: response.url || '',
      responseBody: String(responseText || '').slice(0, 1200),
    };
    window[debugKey] = debugDone;
    logSubmitDebug(`${label} result`, debugDone);

    if (!response.ok) {
      const detail =
        responseJson && (responseJson.detail || responseJson.error)
          ? String(responseJson.detail || responseJson.error)
          : `${label} failed (${response.status}).`;
      throw createSubmitError(detail, {
        status: response.status,
        statusText: response.statusText || '',
        requestId,
      });
    }

    if (!responseJson || responseJson.ok !== true) {
      throw createSubmitError(
        (responseJson && (responseJson.detail || responseJson.error)) || `${label} returned an unexpected response.`
      );
    }

    return responseJson;
  };

  // The draft order is fired upfront (so it survives a reload) and again after the
  // contact form POST resolves. Reuse the in-flight promise so one submission never
  // races itself into two drafts; the worker's submission tag is the second guard.
  const inFlightDraftOrders = new Map();

  // Every click mints a fresh submission id, so the id cannot stop someone
  // pressing Submit twice — that is how one visitor produced ten identical
  // drafts. Remember what was actually ordered and skip a repeat of the same
  // order inside a short window. This only ever suppresses the draft order call:
  // the contact e-mail is sent on its own path, so a request is never lost.
  const DRAFT_HISTORY_KEY = 'im_draft_history_v1';
  const DRAFT_DUPLICATE_WINDOW_MS = 15 * 60 * 1000;

  const hashString = (text) => {
    let hash = 0x811c9dc5;
    for (let i = 0; i < text.length; i += 1) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash.toString(36);
  };

  const draftFingerprint = (flow, payload) => {
    if (!payload) return '';
    const entries = flow === 'sample' ? payload.samples : payload.items;
    if (!Array.isArray(entries) || !entries.length) return '';
    const parts = entries
      .map((entry) => `${entry.variant_id || entry.product_id || entry.product_title || ''}:${entry.qty}`)
      .sort();
    const email = String((payload.contact && payload.contact.email) || '').trim().toLowerCase();
    if (!email) return '';
    return hashString(`${flow}|${email}|${payload.currency}|${parts.join(',')}`);
  };

  const readDraftHistory = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(DRAFT_HISTORY_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  };

  const draftAlreadyCreated = (fingerprint) => {
    if (!fingerprint) return false;
    const at = Number(readDraftHistory()[fingerprint]);
    if (!Number.isFinite(at)) return false;
    return Date.now() - at < DRAFT_DUPLICATE_WINDOW_MS;
  };

  // Recorded only once the worker has confirmed the draft, so a failed attempt
  // never blocks the retry that would have rescued it.
  const rememberDraftCreated = (fingerprint) => {
    if (!fingerprint) return;
    try {
      const history = readDraftHistory();
      const cutoff = Date.now() - DRAFT_DUPLICATE_WINDOW_MS;
      Object.keys(history).forEach((key) => {
        if (!Number.isFinite(Number(history[key])) || Number(history[key]) < cutoff) delete history[key];
      });
      history[fingerprint] = Date.now();
      window.localStorage.setItem(DRAFT_HISTORY_KEY, JSON.stringify(history));
    } catch (error) {
      // Storage is a convenience here; the worker still de-duplicates.
    }
  };

  const postDraftOrderOnce = (flow, payload, run) => {
    const fingerprint = draftFingerprint(flow, payload);
    if (draftAlreadyCreated(fingerprint)) {
      logSubmitDebug(`${flow} draft order skipped — identical order already created`, { fingerprint });
      return Promise.resolve({ ok: true, action: 'skipped_duplicate_client', fingerprint });
    }
    return run().then((result) => {
      if (result && result.ok) rememberDraftCreated(fingerprint);
      return result;
    });
  };

  const runDraftOrderOnce = (key, run) => {
    if (!key) return run();
    const existing = inFlightDraftOrders.get(key);
    if (existing) return existing;
    const promise = run().catch((error) => {
      inFlightDraftOrders.delete(key);
      throw error;
    });
    inFlightDraftOrders.set(key, promise);
    return promise;
  };

  const createSampleDraftOrder = (payload) => {
    const submissionId = String((payload && payload.submission_id) || '').trim();
    return postDraftOrderOnce('sample', payload, () =>
      runDraftOrderOnce(submissionId ? `sample:${submissionId}` : '', () =>
      postDraftOrder(
        {
          endpoint: '/apps/im-lead-upsert/sample-draft-order',
          mode: 'sample-draft-order-proxy',
          label: 'Sample draft order',
          debugKey: '__IM_LAST_SAMPLE_DRAFT_DEBUG',
        },
        payload
      )
      )
    );
  };

  const createQuoteDraftOrder = (payload) => {
    const submissionId = String((payload && payload.submission_id) || '').trim();
    return postDraftOrderOnce('quote', payload, () =>
      runDraftOrderOnce(submissionId ? `quote:${submissionId}` : '', () =>
      postDraftOrder(
        {
          endpoint: '/apps/im-lead-upsert/quote-draft-order',
          mode: 'quote-draft-order-proxy',
          label: 'Quote draft order',
          debugKey: '__IM_LAST_QUOTE_DRAFT_DEBUG',
        },
        payload
      )
      )
    );
  };

  const fireSampleDraftOrderUpfront = (modal, form) => {
    if (modal !== sampleModal) return;
    const payload = buildSamplePayload(form);
    if (!payload || !payload.contact || !payload.contact.email) return;
    if (!Array.isArray(payload.samples) || !payload.samples.length) return;
    try {
      submitSampleDraftOrderForModal(modal, form).catch((error) => {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[IM Submit Debug] Upfront sample draft order failed:', error);
        }
      });
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[IM Submit Debug] Upfront sample draft order threw:', error);
      }
    }
  };

  const submitSampleDraftOrderForModal = async (modal, form) => {
    if (modal !== sampleModal) return { ok: true, skipped: 'not_sample_modal' };
    const payload = buildSamplePayload(form);
    if (!payload) return { ok: true, skipped: 'missing_payload' };
    if (!payload.contact || !payload.contact.email) {
      return { ok: true, skipped: 'missing_email' };
    }
    if (!Array.isArray(payload.samples) || !payload.samples.length) {
      return { ok: true, skipped: 'missing_samples' };
    }
    return createSampleDraftOrder(payload);
  };

  const fireQuoteDraftOrderUpfront = (modal, form) => {
    if (modal !== quoteModal) return;
    const payload = buildQuotePayload(form);
    if (!payload || !payload.contact || !payload.contact.email) return;
    if (!Array.isArray(payload.items) || !payload.items.length) return;
    try {
      submitQuoteDraftOrderForModal(modal, form).catch((error) => {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[IM Submit Debug] Upfront quote draft order failed:', error);
        }
      });
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[IM Submit Debug] Upfront quote draft order threw:', error);
      }
    }
  };

  const submitQuoteDraftOrderForModal = async (modal, form) => {
    if (modal !== quoteModal) return { ok: true, skipped: 'not_quote_modal' };
    const payload = buildQuotePayload(form);
    if (!payload) return { ok: true, skipped: 'missing_payload' };
    if (!payload.contact || !payload.contact.email) {
      return { ok: true, skipped: 'missing_email' };
    }
    if (!Array.isArray(payload.items) || !payload.items.length) {
      return { ok: true, skipped: 'missing_items' };
    }
    return createQuoteDraftOrder(payload);
  };

  const removeCaptchaLikeFields = (payload) => {
    if (!payload) return;
    Array.from(payload.keys()).forEach((key) => {
      if (String(key || '').toLowerCase().indexOf('captcha') !== -1) {
        payload.delete(key);
      }
    });
  };

  const appendCaptchaEntriesFromForm = (form, payload) => {
    if (!form || !payload) return;
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      if (typeof value !== 'string') return;
      const normalizedKey = String(key || '').toLowerCase();
      if (!normalizedKey || normalizedKey.indexOf('captcha') === -1) return;
      const normalizedValue = String(value || '').trim();
      if (!normalizedValue) return;
      payload.set(key, normalizedValue);
    });
  };

  const hasCaptchaValue = (payload) =>
    Array.from(payload.keys()).some((key) => {
      const normalizedKey = String(key || '').toLowerCase();
      return normalizedKey.indexOf('captcha') !== -1 && String(payload.get(key) || '').trim() !== '';
    });

  const buildContactRequestPayload = (form) => {
    const payload = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (typeof value === 'string') {
        payload.append(key, value);
      }
    });
    removeCaptchaLikeFields(payload);
    return payload;
  };

  const resolveCaptchaProtectedPayload = (form, mode) =>
    new Promise((resolve, reject) => {
      const captchaApi =
        window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function'
          ? window.Shopify.captcha
          : null;
      if (!captchaApi) {
        reject(
          createSubmitError('CAPTCHA is still loading. Please try again.', {
            reason: `${String(mode || 'contact-submit')} captcha API unavailable`,
          })
        );
        return;
      }

      let settled = false;
      let timeoutId = null;

      const settle = (resolver, value) => {
        if (settled) return;
        settled = true;
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
        form.dataset.imCaptureCaptchaSubmit = '';
        form.removeEventListener('submit', onSubmitCapture, true);
        resolver(value);
      };

      const onSubmitCapture = (event) => {
        if (form.dataset.imCaptureCaptchaSubmit !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const payload = buildContactRequestPayload(form);
        appendCaptchaEntriesFromForm(form, payload);
        if (!hasCaptchaValue(payload)) {
          settle(
            reject,
            createSubmitError('Missing CAPTCHA token. Please try again.', {
              reason: `${String(mode || 'contact-submit')} missing captcha token`,
            })
          );
          return;
        }
        settle(resolve, payload);
      };

      timeoutId = window.setTimeout(() => {
        settle(
          reject,
          createSubmitError('CAPTCHA verification timed out. Please try again.', {
            reason: `${String(mode || 'contact-submit')} captcha timeout`,
          })
        );
      }, 12000);

      form.addEventListener('submit', onSubmitCapture, true);

      const triggerProtectedSubmitCapture = () => {
        form.dataset.imCaptureCaptchaSubmit = 'true';
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        } catch (error) {
          settle(
            reject,
            createSubmitError('Could not start protected submit. Please try again.', {
              reason: `${String(mode || 'contact-submit')} trigger submit failed`,
            })
          );
        }
      };

      try {
        form.setAttribute('data-shopify-captcha', 'true');
        captchaApi.protect(form, () => {
          triggerProtectedSubmitCapture();
        });
      } catch (error) {
        settle(
          reject,
          createSubmitError('CAPTCHA verification failed. Please try again.', {
            reason: `${String(mode || 'contact-submit')} captcha.protect threw`,
          })
        );
      }
    });

  const submitInquiryInBackground = async (form, flow) => {
    if (!form) {
      throw createSubmitError('Could not submit. Missing inquiry form.');
    }
    const endpoint = resolveContactEndpoint(form);
    const debugStart = {
      endpoint,
      method: 'POST',
      mode: `${flow}-contact-background`,
      payload: {},
      status: 'pending',
      statusText: '',
      requestId: '',
      responseUrl: '',
      responseBody: '',
    };
    window.__IM_LAST_SUBMIT_DEBUG = debugStart;
    logSubmitDebug('Inquiry submit start', debugStart);

    let payload;
    try {
      payload = await resolveCaptchaProtectedPayload(form, `${flow}-contact-background`);
      debugStart.payload = sanitizeDebugPayload(payload);
    } catch (error) {
      const debugFail = {
        ...debugStart,
        status: 0,
        statusText: 'CAPTCHA_MISSING',
        responseBody: String(error && error.message ? error.message : ''),
      };
      window.__IM_LAST_SUBMIT_DEBUG = debugFail;
      logSubmitDebug('Inquiry submit captcha failure', debugFail);
      throw error;
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
      body: payload.toString(),
    });

    const responseText = await response.text();
    const requestId = String(response.headers.get('x-request-id') || '').trim();
    const debugDone = {
      ...debugStart,
      status: response.status,
      statusText: response.statusText || '',
      requestId,
      responseUrl: response.url || '',
      responseBody: String(responseText || '').slice(0, 1200),
    };
    window.__IM_LAST_SUBMIT_DEBUG = debugDone;
    logSubmitDebug('Inquiry submit result', debugDone);

    if (!response.ok) {
      throw createSubmitError('We could not submit your request right now. Please try again.', {
        status: response.status,
        statusText: response.statusText || '',
        requestId,
      });
    }

    const normalizedBody = String(responseText || '').toLowerCase();
    if (
      normalizedBody.includes('missing captcha token') ||
      normalizedBody.includes('missing or invalid captcha token') ||
      normalizedBody.includes('oauth error') ||
      normalizedBody.includes('oops, something went wrong')
    ) {
      throw createSubmitError('We could not submit your request right now. Please try again.', {
        status: response.status,
        statusText: response.statusText || '',
        requestId,
        reason: 'Unexpected contact response',
      });
    }

    return true;
  };

  const serializeQuoteItems = () => {
    if (!state.quoteItems.length) return '';
    return state.quoteItems
      .map((item) => {
        const variantText = item.variantTitle ? ` / ${item.variantTitle}` : '';
        return `${item.productTitle}${variantText} | Qty: ${item.quantity}`;
      })
      .join('\n');
  };

  const syncAutofill = (scope) => {
    const root = scope || document;
    const variantTitle = state.variant && state.variant.title ? state.variant.title : '';
    const variantId = state.variant && state.variant.id ? String(state.variant.id) : '';

    root.querySelectorAll('[data-im-autofill="product-title"]').forEach((field) => {
      field.value = state.productTitle || '';
    });

    root.querySelectorAll('[data-im-autofill="product-handle"]').forEach((field) => {
      field.value = state.productHandle || '';
    });

    root.querySelectorAll('[data-im-autofill="variant-title"]').forEach((field) => {
      field.value = variantTitle;
    });

    root.querySelectorAll('[data-im-autofill="variant-id"]').forEach((field) => {
      field.value = variantId;
    });

    root.querySelectorAll('[data-im-autofill="estimated-quantity"]').forEach((field) => {
      if (state.estimatedQuantity !== null && state.estimatedQuantity > 0) {
        field.value = String(state.estimatedQuantity);
      }
    });

    root.querySelectorAll('[data-im-autofill="sample-tags"]').forEach((field) => {
      field.value = buildTags('sample_request');
    });

    root.querySelectorAll('[data-im-autofill="quote-tags"]').forEach((field) => {
      field.value = buildTags('project_inquiry');
    });

  };

  const syncQuoteProductsPayload = () => {
    if (quoteProductsInput) {
      quoteProductsInput.value = serializeQuoteItems();
    }
  };

  const isQuoteWizardEnabled = () =>
    !!(
      quoteModal &&
      quoteWizardSteps.length === QUOTE_WIZARD_TOTAL_STEPS &&
      quoteWizardProgress &&
      quoteWizardBackButton &&
      quoteWizardNextButton &&
      quoteWizardSubmitButton
    );

  const hideQuoteProductsError = () => {
    if (!quoteProductsError) return;
    quoteProductsError.hidden = true;
    quoteProductsError.textContent = '';
  };

  const showQuoteProductsError = (message) => {
    if (!quoteProductsError) return;
    quoteProductsError.textContent = message;
    quoteProductsError.hidden = false;
  };

  const ensureFieldErrorNode = (field) => {
    const wrapper = field.closest('.im-modal__field');
    if (!wrapper) return null;
    let errorNode = wrapper.querySelector('[data-im-field-error]');
    if (!errorNode) {
      errorNode = document.createElement('p');
      errorNode.className = 'im-modal__field-error';
      errorNode.setAttribute('data-im-field-error', '');
      errorNode.setAttribute('role', 'alert');
      errorNode.hidden = true;
      wrapper.appendChild(errorNode);
    }

    const sourceId = field.id || field.name || `field-${Math.random().toString(36).slice(2, 8)}`;
    const safeId = sourceId.replace(/[^a-zA-Z0-9_-]+/g, '-');
    errorNode.id = `im-field-error-${safeId}`;
    return errorNode;
  };

  const setFieldError = (field, message) => {
    const wrapper = field.closest('.im-modal__field');
    const errorNode = ensureFieldErrorNode(field);
    if (!errorNode) return;

    const describedBy = new Set(
      String(field.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter(Boolean)
    );
    describedBy.add(errorNode.id);
    field.setAttribute('aria-describedby', Array.from(describedBy).join(' '));
    field.setAttribute('aria-invalid', 'true');
    if (wrapper) wrapper.classList.add('is-invalid');
    errorNode.textContent = message;
    errorNode.hidden = false;
  };

  const clearFieldError = (field) => {
    const wrapper = field.closest('.im-modal__field');
    const errorNode = wrapper ? wrapper.querySelector('[data-im-field-error]') : null;
    if (!errorNode || !errorNode.id) {
      field.removeAttribute('aria-invalid');
      if (wrapper) wrapper.classList.remove('is-invalid');
      return;
    }

    const describedBy = String(field.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter((id) => id && id !== errorNode.id);
    if (describedBy.length) {
      field.setAttribute('aria-describedby', describedBy.join(' '));
    } else {
      field.removeAttribute('aria-describedby');
    }

    field.removeAttribute('aria-invalid');
    if (wrapper) wrapper.classList.remove('is-invalid');
    errorNode.hidden = true;
    errorNode.textContent = '';
  };

  const clearValidationErrors = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('.im-modal__field').forEach((wrapper) => wrapper.classList.remove('is-invalid'));
    scope.querySelectorAll('[data-im-field-error]').forEach((errorNode) => {
      errorNode.hidden = true;
      errorNode.textContent = '';
    });
    scope.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
      field.removeAttribute('aria-invalid');
      const describedBy = String(field.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter((id) => id && !id.startsWith('im-field-error-'));
      if (describedBy.length) {
        field.setAttribute('aria-describedby', describedBy.join(' '));
      } else {
        field.removeAttribute('aria-describedby');
      }
    });
    hideQuoteProductsError();
  };

  const getFieldLabel = (field) => {
    const wrapper = field.closest('.im-modal__field');
    const labelNode = wrapper ? wrapper.querySelector('span') : null;
    if (!labelNode) return 'This field';
    return labelNode.textContent.replace(/\*/g, '').trim() || 'This field';
  };

  const getFieldErrorMessage = (field) => {
    const label = getFieldLabel(field);
    if (field.validity.valueMissing) return `${label} is required.`;
    if (field.validity.typeMismatch) return `Please enter a valid ${label.toLowerCase()}.`;
    if (field.validity.rangeOverflow) return `${label} is too high.`;
    if (field.validity.rangeUnderflow) return `${label} is too low.`;
    if (field.validity.stepMismatch) return `Please enter a valid value for ${label.toLowerCase()}.`;
    return field.validationMessage || `${label} is invalid.`;
  };

  const validateField = (field) => {
    if (!field || !field.willValidate || field.disabled) return true;
    clearFieldError(field);

    const value = String(field.value || '').trim();
    if (!field.required && value === '') return true;
    if (field.checkValidity()) return true;

    setFieldError(field, getFieldErrorMessage(field));
    return false;
  };

  const updateQuoteWizardNav = () => {
    if (!isQuoteWizardEnabled()) return;

    const currentStep = state.quoteWizardStep;
    if (quoteModal) {
      quoteModal.setAttribute('data-im-wizard-step', String(currentStep));
    }
    if (quoteModalTitleNode) {
      quoteModalTitleNode.setAttribute('aria-hidden', currentStep === 1 ? 'false' : 'true');
    }
    if (quoteModalDescriptionNode) {
      quoteModalDescriptionNode.setAttribute('aria-hidden', currentStep === 1 ? 'false' : 'true');
    }
    const titleNode = quoteWizardSteps[currentStep - 1];
    const title = titleNode ? titleNode.getAttribute('data-im-step-title') || '' : '';

    quoteWizardProgress.textContent = buildStepDotsLabel(currentStep, QUOTE_WIZARD_TOTAL_STEPS);
    quoteWizardProgress.setAttribute(
      'aria-label',
      title
        ? `Step ${currentStep} of ${QUOTE_WIZARD_TOTAL_STEPS}: ${title}`
        : `Step ${currentStep} of ${QUOTE_WIZARD_TOTAL_STEPS}`
    );
    if (quoteWizardProgressFill) {
      const percent = (currentStep / QUOTE_WIZARD_TOTAL_STEPS) * 100;
      quoteWizardProgressFill.style.width = `${percent}%`;
    }

    quoteWizardBackButton.hidden = currentStep === 1;
    quoteWizardNextButton.hidden = currentStep === QUOTE_WIZARD_TOTAL_STEPS;
    quoteWizardSubmitButton.hidden = currentStep !== QUOTE_WIZARD_TOTAL_STEPS;
  };

  const setQuoteWizardStep = (step, options = {}) => {
    if (!isQuoteWizardEnabled()) return;
    const requested = Number(step);
    const nextStep = Math.max(1, Math.min(QUOTE_WIZARD_TOTAL_STEPS, Number.isFinite(requested) ? requested : 1));
    state.quoteWizardStep = nextStep;

    quoteWizardSteps.forEach((stepNode, index) => {
      const isActive = index + 1 === nextStep;
      stepNode.classList.toggle('is-active', isActive);
      stepNode.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    updateQuoteWizardNav();

    if (options.focusFirstField) {
      window.requestAnimationFrame(() => {
        const activeStep = quoteWizardSteps[nextStep - 1];
        if (!activeStep) return;
        const focusTarget = activeStep.querySelector('input:not([type="hidden"]), select, textarea, button');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }

    saveQuoteDraft();
  };

  const validateQuoteStep = (step, options = {}) => {
    const focusInvalid = options.focusInvalid !== false;
    const stepNode = quoteWizardSteps[step - 1];
    if (!stepNode) return { valid: true, firstInvalid: null };

    let firstInvalid = null;
    const fields = Array.from(stepNode.querySelectorAll('input, select, textarea'));
    fields.forEach((field) => {
      if (field.type === 'hidden') return;
      const valid = validateField(field);
      if (!valid && !firstInvalid) firstInvalid = field;
    });

    if (step === 2 && !state.quoteItems.length) {
      showQuoteProductsError('Add at least one product to continue.');
      if (!firstInvalid) firstInvalid = quoteSearchInput || stepNode;
    } else if (step === 2) {
      hideQuoteProductsError();
    }

    if (focusInvalid && firstInvalid && typeof firstInvalid.focus === 'function') {
      firstInvalid.focus();
    }

    return { valid: !firstInvalid, firstInvalid };
  };

  const validateAllQuoteSteps = () => {
    for (let step = 1; step <= QUOTE_WIZARD_TOTAL_STEPS; step += 1) {
      const result = validateQuoteStep(step, { focusInvalid: false });
      if (!result.valid) return { valid: false, step, firstInvalid: result.firstInvalid };
    }
    return { valid: true, step: null, firstInvalid: null };
  };

  const maybeAutofillQuoteLocation = async () => {
    if (!quoteModal || state.locationAttempted) return;
    const countryField = quoteModal.querySelector('[data-im-field="country"]');
    const cityField = quoteModal.querySelector('[data-im-field="city"]');
    if (!countryField || !cityField) return;
    if (getFieldValue(countryField) && getFieldValue(cityField)) return;

    state.locationAttempted = true;
    const populate = (countryValue, cityValue) => {
      const country = String(countryValue || '').trim();
      const city = String(cityValue || '').trim();
      let changed = false;
      if (country && !getFieldValue(countryField)) {
        countryField.value = country;
        changed = true;
      }
      if (city && !getFieldValue(cityField)) {
        cityField.value = city;
        changed = true;
      }
      if (changed) saveQuoteDraft();
    };

    try {
      const primaryResponse = await fetch('https://ipapi.co/json/', {
        headers: { Accept: 'application/json' },
      });
      if (primaryResponse.ok) {
        const primaryPayload = await primaryResponse.json();
        populate(primaryPayload && primaryPayload.country_name, primaryPayload && primaryPayload.city);
      }
    } catch (error) {
      // Best-effort only.
    }

    if (getFieldValue(countryField) && getFieldValue(cityField)) return;

    try {
      const fallbackResponse = await fetch('https://ipwho.is/', {
        headers: { Accept: 'application/json' },
      });
      if (!fallbackResponse.ok) return;
      const fallbackPayload = await fallbackResponse.json();
      populate(fallbackPayload && fallbackPayload.country, fallbackPayload && fallbackPayload.city);
    } catch (error) {
      // Best-effort only.
    }
  };

  const setQuoteItems = (items) => {
    const normalizedItems = Array.isArray(items) ? items.map((item) => sanitizeQuoteItem(item)).filter(Boolean) : [];
    const uniqueItems = [];
    const seenKeys = new Set();

    normalizedItems.forEach((item) => {
      const key = quoteItemKey(item);
      if (!key || seenKeys.has(key)) return;
      seenKeys.add(key);
      uniqueItems.push(item);
    });

    state.quoteItems = uniqueItems;
    saveQuoteItems();
    renderQuoteItems();
    syncQuoteProductsPayload();
    syncAutofill(document);
    hydrateQuoteVariantOptions();
    refreshQuoteSearchResults();
  };

  const getQuoteItemsForHandle = (handle, excludeKey) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return [];
    return state.quoteItems.filter((item) => {
      if (String(item.productHandle || '').trim() !== normalizedHandle) return false;
      if (excludeKey && quoteItemKey(item) === excludeKey) return false;
      return true;
    });
  };

  const getSelectedVariantIdsForHandle = (handle, excludeKey) =>
    new Set(
      getQuoteItemsForHandle(handle, excludeKey)
        .map((item) => toNumber(item.variantId))
        .filter((variantId) => variantId !== null)
    );

  const getVariantOptionsForAdd = (handle) => {
    const options = getVariantOptionsForHandle(handle);
    if (!options.length) return [];
    // Quote requests can include unavailable variants for planning or restock timelines.
    return options;
  };

  const getDefaultVariantForHandle = (handle) => {
    const options = getVariantOptionsForAdd(handle);
    if (!options.length) return null;
    return options.find((variant) => variant.available !== false) || options[0];
  };

  const getNextUnusedVariantForHandle = (handle, startVariantId, excludeKey) => {
    const options = getVariantOptionsForAdd(handle);
    if (!options.length) return null;

    const selectedIds = getSelectedVariantIdsForHandle(handle, excludeKey);
    if (selectedIds.size >= options.length) return null;

    let startIndex = 0;
    const normalizedStartId = toNumber(startVariantId);
    if (normalizedStartId !== null) {
      const matchedIndex = options.findIndex((variant) => variant.id === normalizedStartId);
      if (matchedIndex > -1) startIndex = (matchedIndex + 1) % options.length;
    }

    for (let index = 0; index < options.length; index += 1) {
      const candidate = options[(startIndex + index) % options.length];
      if (!selectedIds.has(candidate.id)) return candidate;
    }
    return null;
  };

  const getVariantByIdFromHandle = (handle, variantId) => {
    const normalizedVariantId = toNumber(variantId);
    if (normalizedVariantId === null) return null;
    const options = getVariantOptionsForAdd(handle);
    return options.find((variant) => variant.id === normalizedVariantId) || null;
  };

  const getPreferredVariantForAdd = (handle, preferredVariantId) => {
    const options = getVariantOptionsForAdd(handle);
    if (!options.length) return null;

    const selectedIds = getSelectedVariantIdsForHandle(handle);
    const preferredId = toNumber(preferredVariantId);
    if (preferredId !== null) {
      const preferredVariant = options.find((variant) => variant.id === preferredId);
      if (preferredVariant && !selectedIds.has(preferredVariant.id)) return preferredVariant;
    }

    const contextId = getQuoteSelectorVariant(handle);
    if (contextId !== null) {
      const contextVariant = options.find((variant) => variant.id === contextId);
      if (contextVariant) {
        if (!selectedIds.has(contextVariant.id)) return contextVariant;
        const nextFromContext = getNextUnusedVariantForHandle(handle, contextVariant.id);
        if (nextFromContext) return nextFromContext;
      }
    }

    const defaultVariant = getDefaultVariantForHandle(handle);
    if (defaultVariant && !selectedIds.has(defaultVariant.id)) return defaultVariant;

    return getNextUnusedVariantForHandle(handle, contextId || (defaultVariant && defaultVariant.id));
  };

  const getQuoteAddLimitState = (handle, preferredVariantId) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) {
      return {
        reason: 'missing-handle',
        label: 'Add',
        notice: '',
        noticeType: 'info',
      };
    }

    const nextVariant = getPreferredVariantForAdd(normalizedHandle, preferredVariantId);
    if (nextVariant) {
      return {
        reason: 'can-add',
        label: 'Add',
        notice: '',
        noticeType: 'info',
      };
    }

    const variantCount = getVariantOptionsForAdd(normalizedHandle).length;
    const selectedCount = getSelectedVariantIdsForHandle(normalizedHandle).size;

    if (variantCount === 0) {
      return {
        reason: 'can-add',
        label: 'Add',
        notice: '',
        noticeType: 'info',
      };
    }

    if (selectedCount > 0 && variantCount <= 1) {
      return {
        reason: 'already-added',
        label: 'Added',
        notice: 'Product already added.',
        noticeType: 'info',
      };
    }

    if (selectedCount > 0 && variantCount > 1) {
      return {
        reason: 'all-variants-added',
        label: 'All colors added',
        notice: 'All colors added for this product.',
        noticeType: 'warning',
      };
    }

    return {
      reason: 'unavailable',
      label: 'Unavailable',
      notice: 'This product cannot be selected right now.',
      noticeType: 'warning',
    };
  };

  const getQuoteSearchResultState = (handle, preferredVariantId) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) {
      return {
        reason: 'missing-handle',
        label: 'Add',
        notice: '',
        noticeType: 'info',
      };
    }

    const preferredId = toNumber(preferredVariantId);
    if (preferredId !== null) {
      const exactVariant = getVariantByIdFromHandle(normalizedHandle, preferredId);
      if (!exactVariant) {
        return {
          reason: 'unavailable',
          label: 'Unavailable',
          notice: 'This product cannot be selected right now.',
          noticeType: 'warning',
        };
      }

      const alreadyAdded = state.quoteItems.some((item) => {
        return (
          String(item.productHandle || '').trim() === normalizedHandle &&
          toNumber(item.variantId) === preferredId
        );
      });
      if (alreadyAdded) {
        return {
          reason: 'already-added',
          label: 'Added',
          notice: 'Color already added.',
          noticeType: 'info',
        };
      }

      return {
        reason: 'can-add',
        label: 'Add',
        notice: '',
        noticeType: 'info',
      };
    }

    return getQuoteAddLimitState(normalizedHandle, preferredVariantId);
  };

  const highlightQuoteItemByVariantId = (variantId) => {
    if (!quoteProductsContainer) return;
    const normalizedVariantId = toNumber(variantId);
    if (normalizedVariantId === null) return;

    const row = quoteProductsContainer.querySelector(
      `[data-im-quote-variant-id="${String(normalizedVariantId)}"]`
    );
    if (!row) return;
    row.classList.add('is-highlighted');
    row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    window.setTimeout(() => {
      row.classList.remove('is-highlighted');
    }, 1100);
  };

  const addQuoteItem = (item, options = {}) => {
    const normalizedItem = sanitizeQuoteItem(item);
    if (!normalizedItem) return { ok: false, reason: 'invalid' };

    // Variant-level uniqueness: each selected line item is unique by variant_id.
    const key = quoteItemKey(normalizedItem);
    const existingItem = state.quoteItems.find((entry) => quoteItemKey(entry) === key);
    if (existingItem) {
      if (options.showDuplicateNotice !== false) {
        showQuoteStatus('Product already added.', 'warning');
      }
      highlightQuoteItemByVariantId(existingItem.variantId);
      return { ok: false, reason: 'duplicate', item: existingItem };
    }

    setQuoteItems([...state.quoteItems, normalizedItem]);
    return { ok: true, item: normalizedItem };
  };

  const addCurrentProductToQuoteList = (options = {}) => {
    readVariantFromDom();
    const handle = state.productHandle;
    if (!handle) return { ok: false, reason: 'missing-handle' };

    const onlyIfMissing = options.onlyIfMissing === true;
    const currentVariantId = state.variant && state.variant.id ? toNumber(state.variant.id) : null;
    const preferredVariantId = options.preferredVariantId || currentVariantId;
    let selectedVariant = null;
    if (onlyIfMissing) {
      selectedVariant =
        getVariantByIdFromHandle(handle, preferredVariantId) ||
        getVariantByIdFromHandle(handle, getQuoteSelectorVariant(handle)) ||
        getDefaultVariantForHandle(handle);
      if (selectedVariant) {
        const existingItem = state.quoteItems.find((item) => toNumber(item.variantId) === selectedVariant.id);
        if (existingItem) {
          const existingQuantity = clampQuantity(existingItem.quantity);
          const estimatedQuantity =
            state.estimatedQuantity && state.estimatedQuantity > 0
              ? clampQuantity(state.estimatedQuantity)
              : null;
          if (
            estimatedQuantity !== null &&
            estimatedQuantity === existingQuantity &&
            existingQuantity !== QUOTE_DEFAULT_ITEM_QUANTITY
          ) {
            const existingKey = quoteItemKey(existingItem);
            if (existingKey) {
              updateQuoteItemQuantity(existingKey, QUOTE_DEFAULT_ITEM_QUANTITY);
            }
          }
          return { ok: false, reason: 'already-added' };
        }
      }
    } else {
      selectedVariant = getPreferredVariantForAdd(handle, preferredVariantId);
    }

    if (!selectedVariant) {
      if (!onlyIfMissing) {
        const addLimitState = getQuoteAddLimitState(handle, preferredVariantId);
        if (addLimitState.notice) {
          showQuoteStatus(addLimitState.notice, addLimitState.noticeType);
        }
        return { ok: false, reason: addLimitState.reason };
      }
      return { ok: false, reason: 'all-variants-added' };
    }

    const preferredQuantity = QUOTE_DEFAULT_ITEM_QUANTITY;
    const productItem = sanitizeQuoteItem({
      productId: state.productId,
      productHandle: handle,
      productTitle: state.productTitle,
      variantId: selectedVariant.id,
      variantTitle: selectedVariant.title,
      image: selectedVariant.image || getVariantImage(state.variant),
      quantity: preferredQuantity,
    });
    const result = addQuoteItem(productItem, {
      showDuplicateNotice: !onlyIfMissing,
    });
    if (!result.ok) return result;

    // Auto-advance selector to the next not-yet-selected variant.
    const nextVariant = getNextUnusedVariantForHandle(handle, selectedVariant.id);
    if (nextVariant) {
      setQuoteSelectorVariant(handle, nextVariant.id);
    } else {
      setQuoteSelectorVariant(handle, selectedVariant.id);
      if (getVariantOptionsForAdd(handle).length > 1) {
        showQuoteStatus('All colors added for this product.', 'info');
      }
    }
    return result;
  };

  const renderQuoteSearchMessage = (message) => {
    if (!quoteSearchResults) return;
    quoteSearchResults.innerHTML = '';
    const node = document.createElement('p');
    node.className = 'im-quote-products__search-message';
    node.textContent = message;
    quoteSearchResults.appendChild(node);
    updateScrollHintState(quoteSearchResults);
  };

  const buildCatalogEntry = (product) => {
    if (!product) return null;
    const productId = toNumber(product.id);
    const productTitle = String(product.title || '').trim();
    const productHandle = String(product.handle || '').trim();
    if (!productTitle || !productHandle) return null;

    const productImage = extractImageSrc(
      product.image ||
        product.featured_image ||
        (Array.isArray(product.images) ? product.images[0] : '')
    );
    const variantOptions = buildVariantOptions(
      product.variants,
      productImage,
      null,
      product.options
    );
    if (variantOptions.length) {
      setVariantOptionsForHandle(productHandle, variantOptions);
    }

    const variantsSearch = variantOptions
      .map((option) => {
        const optionValues = Array.isArray(option.optionValues) ? option.optionValues.join(' ') : '';
        return `${option.title || ''} ${option.colorLabel || ''} ${optionValues} ${option.searchText || ''}`;
      })
      .join(' ');
    const variantsOptionValues = Array.isArray(product.variants)
      ? product.variants
          .map((variant) => `${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`)
          .join(' ')
      : '';
    const productTags = getTagsList(product.tags);
    return {
      productId,
      productTitle,
      productHandle,
      image: productImage,
      variants: variantOptions,
      tags: productTags,
      sampleEligible: isSampleEligibleProduct({ tags: productTags }),
      searchText: normalizeLabel(`${productTitle} ${productHandle} ${variantsSearch} ${variantsOptionValues}`),
    };
  };

  const buildCatalogEntries = (products) => {
    if (!Array.isArray(products)) return [];
    return products
      .map((product) => buildCatalogEntry(product))
      .filter(Boolean)
      .sort((a, b) => a.productTitle.localeCompare(b.productTitle));
  };

  const getMatchingVariantForTerms = (catalogProduct, terms) => {
    if (!catalogProduct || !Array.isArray(catalogProduct.variants) || !catalogProduct.variants.length) {
      return null;
    }
    if (!Array.isArray(terms) || !terms.length) {
      return null;
    }

    const normalizedTerms = terms.map((term) => normalizeLabel(term)).filter(Boolean);
    if (!normalizedTerms.length) return null;

    const candidates = catalogProduct.variants.map((variant) => {
      const optionValues = Array.isArray(variant.optionValues) ? variant.optionValues.join(' ') : '';
      const variantSearchText = normalizeLabel(
        `${catalogProduct.productTitle} ${variant.searchText || ''} ${variant.title || ''} ${variant.colorLabel || ''} ${optionValues}`
      );
      const matchesCount = normalizedTerms.reduce(
        (count, term) => (variantSearchText.includes(term) ? count + 1 : count),
        0
      );
      return {
        variant,
        variantSearchText,
        matchesCount,
      };
    });

    const perfectMatch = candidates.find((candidate) =>
      normalizedTerms.every((term) => candidate.variantSearchText.includes(term))
    );
    if (perfectMatch) return perfectMatch.variant;

    const bestPartial = candidates
      .filter((candidate) => candidate.matchesCount > 0)
      .sort((a, b) => b.matchesCount - a.matchesCount)[0];
    return bestPartial ? bestPartial.variant : null;
  };

  const filterQuoteCatalogEntries = (query) => {
    if (!quoteCatalogProducts.length) return [];

    const normalizedQuery = normalizeLabel(query);
    const terms = normalizedQuery ? normalizedQuery.split(' ').filter(Boolean) : [];

    return quoteCatalogProducts
      .filter((product) => {
        if (!terms.length) return true;
        return terms.every((term) => product.searchText.includes(term));
      })
      .slice(0, PRODUCT_CATALOG_RESULTS_LIMIT)
      .map((product) => {
        const matchedVariant = getMatchingVariantForTerms(product, terms);
        const matchedVariantLabel = matchedVariant
          ? (matchedVariant.colorLabel ||
            (Array.isArray(matchedVariant.optionValues) ? matchedVariant.optionValues[0] : '') ||
            normalizeVariantTitle(matchedVariant.title || ''))
          : '';
        return {
          productId: product.productId,
          productTitle: product.productTitle,
          productHandle: product.productHandle,
          image: matchedVariant && matchedVariant.image ? matchedVariant.image : product.image,
          matchedVariantId: matchedVariant ? matchedVariant.id : null,
          matchedVariantTitle: matchedVariantLabel,
        };
      });
  };

  const loadQuoteCatalog = async () => {
    if (quoteCatalogLoaded) return quoteCatalogProducts;
    if (quoteCatalogLoading) return quoteCatalogProducts;

    quoteCatalogLoading = true;
    try {
      const response = await fetch(buildShopifyUrl(`products.json?limit=${PRODUCT_CATALOG_LIMIT}`), {
        headers: {
          Accept: 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`Products catalog fetch failed: ${response.status}`);
      }

      const payload = await response.json();
      quoteCatalogProducts = buildCatalogEntries(payload && payload.products ? payload.products : []);
      quoteCatalogLoaded = true;
      return quoteCatalogProducts;
    } finally {
      quoteCatalogLoading = false;
    }
  };

  const renderQuoteSearchResults = (items, queryValue) => {
    if (!quoteSearchResults) return;

    quoteSearchResults.innerHTML = '';
    items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'im-quote-products__search-item';

      const lead = document.createElement('div');
      lead.className = 'im-quote-products__search-lead';

      if (item.image) {
        const thumb = document.createElement('img');
        thumb.className = 'im-quote-products__search-thumb';
        thumb.src = item.image;
        thumb.alt = item.productTitle || item.productHandle || 'Product';
        thumb.width = 56;
        thumb.height = 56;
        thumb.loading = 'lazy';
        lead.appendChild(thumb);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'im-quote-products__search-thumb-placeholder';
        placeholder.textContent = 'No image';
        lead.appendChild(placeholder);
      }

      const meta = document.createElement('div');
      meta.className = 'im-quote-products__search-meta';

      const name = document.createElement('p');
      name.className = 'im-quote-products__search-name';
      name.textContent = item.productTitle || item.productHandle || 'Product';
      meta.appendChild(name);

      if (item.matchedVariantTitle && String(queryValue || '').trim()) {
        const match = document.createElement('p');
        match.className = 'im-quote-products__search-match';
        const swatchHex = getColorSwatchHex(item.matchedVariantTitle);
        if (swatchHex) {
          const swatch = document.createElement('span');
          swatch.className = 'im-quote-products__search-swatch';
          swatch.style.setProperty('--im-swatch-color', swatchHex);
          swatch.setAttribute('aria-hidden', 'true');
          match.appendChild(swatch);
        }

        const label = document.createElement('span');
        label.textContent = `Color: ${truncateText(item.matchedVariantTitle, 26)}`;
        match.appendChild(label);
        match.title = item.matchedVariantTitle;
        meta.appendChild(match);
      }

      lead.appendChild(meta);
      row.appendChild(lead);

      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'im-quote-products__search-add';
      addButton.textContent = 'Add';
      const addLabelProduct = item.productTitle || item.productHandle || 'product';
      const addLabelVariant = item.matchedVariantTitle ? `, ${item.matchedVariantTitle}` : '';
      addButton.setAttribute('aria-label', `Add ${addLabelProduct}${addLabelVariant} to quote`);
      addButton.setAttribute('data-im-quote-search-add', '');
      addButton.setAttribute('data-im-quote-product-id', item.productId ? String(item.productId) : '');
      addButton.setAttribute('data-im-quote-handle', item.productHandle || '');
      addButton.setAttribute('data-im-quote-product-title', item.productTitle || '');
      addButton.setAttribute(
        'data-im-quote-preferred-variant-id',
        item.matchedVariantId ? String(item.matchedVariantId) : ''
      );

      const addLimitState = getQuoteSearchResultState(item.productHandle, item.matchedVariantId);
      addButton.disabled = addLimitState.reason !== 'can-add';
      addButton.textContent = addLimitState.label;
      row.appendChild(addButton);

      quoteSearchResults.appendChild(row);
    });
    updateScrollHintState(quoteSearchResults);
  };

  const fetchProductDetailsForQuote = async (handle) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;

    if (quoteProductDetailsCache.has(normalizedHandle)) {
      return quoteProductDetailsCache.get(normalizedHandle);
    }

    const response = await fetch(buildShopifyUrl(`products/${normalizedHandle}.js`), {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Product fetch failed: ${response.status}`);
    }

    const payload = await response.json();
    const productImage = extractImageSrc(
      payload && (payload.featured_image || (Array.isArray(payload.images) ? payload.images[0] : ''))
    );
    const variantOptions = buildVariantOptions(payload && payload.variants, productImage, null, payload && payload.options);
    if (variantOptions.length) {
      setVariantOptionsForHandle(normalizedHandle, variantOptions);
    }
    quoteProductDetailsCache.set(normalizedHandle, payload);
    return payload;
  };

  const addProductByHandleToQuoteList = async (handle, preferredVariantId, productHint = {}, options = {}) => {
    const product = await fetchProductDetailsForQuote(handle);
    if (!product) return;

    const normalizedHandle = product.handle || handle;
    const strictPreferred = options && options.strictPreferred === true;
    const preferredId = toNumber(preferredVariantId);
    let selectedVariant =
      strictPreferred && preferredId !== null
        ? getVariantByIdFromHandle(normalizedHandle, preferredId)
        : null;

    if (!selectedVariant) {
      selectedVariant = getPreferredVariantForAdd(normalizedHandle, preferredVariantId);
    }
    if (!selectedVariant) {
      const addLimitState = strictPreferred
        ? getQuoteSearchResultState(normalizedHandle, preferredVariantId)
        : getQuoteAddLimitState(normalizedHandle, preferredVariantId);
      if (addLimitState.notice) {
        showQuoteStatus(addLimitState.notice, addLimitState.noticeType);
      }
      return { ok: false, reason: addLimitState.reason };
    }

    const preferredQuantity = QUOTE_DEFAULT_ITEM_QUANTITY;
    const productItem = sanitizeQuoteItem({
      productId: toNumber(product.id || productHint.productId),
      productHandle: normalizedHandle,
      productTitle: product.title || productHint.productTitle || handle,
      variantId: selectedVariant.id,
      variantTitle: selectedVariant.title || '',
      image:
        selectedVariant.image ||
        extractImageSrc(product.featured_image || (Array.isArray(product.images) ? product.images[0] : '')),
      quantity: preferredQuantity,
    });

    const result = addQuoteItem(productItem, { showDuplicateNotice: true });
    if (!result.ok) return result;

    if (strictPreferred) {
      setQuoteSelectorVariant(normalizedHandle, selectedVariant.id);
    } else {
      // Auto-advance selector to the next not-yet-selected variant in variant order.
      const nextVariant = getNextUnusedVariantForHandle(normalizedHandle, selectedVariant.id);
      if (nextVariant) {
        setQuoteSelectorVariant(normalizedHandle, nextVariant.id);
      } else {
        setQuoteSelectorVariant(normalizedHandle, selectedVariant.id);
        if (getVariantOptionsForAdd(normalizedHandle).length > 1) {
          showQuoteStatus('All colors added for this product.', 'info');
        }
      }
    }
    return result;
  };

  const runQuoteSearch = async (query) => {
    if (!quoteSearchResults) return;
    const normalizedQuery = String(query || '').trim();

    if (!quoteCatalogLoaded && normalizedQuery.length < 2) {
      clearQuoteSearchResults();
      return;
    }

    const requestId = ++quoteSearchRequestId;
    if (!quoteCatalogLoaded) {
      renderQuoteSearchMessage('Loading products...');
      try {
        await loadQuoteCatalog();
      } catch (error) {
        if (requestId !== quoteSearchRequestId) return;
        renderQuoteSearchMessage('Could not load products right now. Please try again.');
        return;
      }
    }
    if (requestId !== quoteSearchRequestId) return;

    const catalogResults = filterQuoteCatalogEntries(normalizedQuery);
    if (!catalogResults.length) {
      renderQuoteSearchMessage('No matching products or variations found.');
      return;
    }
    renderQuoteSearchResults(catalogResults, normalizedQuery);
  };

  const refreshQuoteSearchResults = () => {
    if (!quoteSearchResults || !quoteSearchInput) return;
    const query = quoteSearchInput.value || '';
    if (!quoteCatalogLoaded && String(query).trim().length < 2) return;
    runQuoteSearch(query);
  };

  const hydrateQuoteVariantOptions = async () => {
    const handles = Array.from(
      new Set(
        state.quoteItems
          .map((item) => String(item && item.productHandle ? item.productHandle : '').trim())
          .filter(Boolean)
      )
    );

    if (!handles.length) return;

    await Promise.all(
      handles.map(async (handle) => {
        if (getVariantOptionsForHandle(handle).length) return;
        try {
          await fetchProductDetailsForQuote(handle);
        } catch (error) {
          // Best-effort only.
        }
      })
    );

    renderQuoteItems();
    refreshQuoteSearchResults();
  };

  const removeQuoteItem = (key) => {
    const currentItem = state.quoteItems.find((item) => quoteItemKey(item) === key);
    if (!currentItem) return;
    if (currentItem.productHandle && currentItem.variantId !== null) {
      setQuoteSelectorVariant(currentItem.productHandle, currentItem.variantId);
    }
    setQuoteItems(state.quoteItems.filter((item) => quoteItemKey(item) !== key));
  };

  const updateQuoteItemQuantity = (key, quantity, options = {}) => {
    const itemIndex = state.quoteItems.findIndex((item) => quoteItemKey(item) === key);
    if (itemIndex < 0) return;

    const shouldRerender = options.rerender !== false;
    const normalizedQuantity = clampQuantity(quantity);
    state.quoteItems[itemIndex] = {
      ...state.quoteItems[itemIndex],
      quantity: normalizedQuantity,
    };

    saveQuoteItems();
    syncQuoteProductsPayload();
    syncAutofill(document);
    if (shouldRerender) renderQuoteItems();
  };

  const updateQuoteItemVariant = (key, variantId) => {
    const itemIndex = state.quoteItems.findIndex((item) => quoteItemKey(item) === key);
    if (itemIndex < 0) return { ok: false, reason: 'missing-item' };

    const item = state.quoteItems[itemIndex];
    const variantOptions = getVariantOptionsForAdd(item.productHandle);
    if (!variantOptions.length) return { ok: false, reason: 'missing-variants' };

    const selectedVariantId = toNumber(variantId);
    const selectedVariant = variantOptions.find((variant) => variant.id === selectedVariantId);
    if (!selectedVariant) return { ok: false, reason: 'invalid-variant' };

    const duplicate = state.quoteItems.find(
      (candidate) => candidate.variantId === selectedVariant.id && quoteItemKey(candidate) !== key
    );
    if (duplicate) {
      showQuoteStatus('This color is already added.', 'warning');
      highlightQuoteItemByVariantId(selectedVariant.id);
      return { ok: false, reason: 'duplicate-variant' };
    }

    state.quoteItems[itemIndex] = {
      ...item,
      variantId: selectedVariant.id,
      variantTitle: selectedVariant.title || '',
      image: selectedVariant.image || item.image,
    };
    setQuoteSelectorVariant(item.productHandle, selectedVariant.id);

    saveQuoteItems();
    renderQuoteItems();
    syncQuoteProductsPayload();
    syncAutofill(document);
    refreshQuoteSearchResults();
    return { ok: true };
  };

  const renderQuoteItems = () => {
    if (!quoteProductsContainer) return;

    quoteProductsContainer.innerHTML = '';

    if (!state.quoteItems.length) {
      const emptyNode = document.createElement('p');
      emptyNode.className = 'im-quote-products__empty';
      emptyNode.textContent = 'No products added yet. Search by product name or color, then add.';
      quoteProductsContainer.appendChild(emptyNode);
      syncQuoteProductsPayload();
      updateScrollHintState(quoteProductsContainer);
      return;
    }

    hideQuoteProductsError();
    showQuoteStatus('', 'info');
    let hasItemMutation = false;

    state.quoteItems.forEach((item) => {
      const variantOptions = getVariantOptionsForHandle(item.productHandle);
      const preferredVariant =
        variantOptions.find((variant) => variant.id === item.variantId) ||
        variantOptions.find((variant) => variant.available) ||
        variantOptions[0] ||
        null;

      if (preferredVariant && (item.variantId !== preferredVariant.id || item.variantTitle !== preferredVariant.title)) {
        item.variantId = preferredVariant.id;
        item.variantTitle = preferredVariant.title || '';
        if (preferredVariant.image) item.image = preferredVariant.image;
        hasItemMutation = true;
      }

      const key = quoteItemKey(item);

      const row = document.createElement('article');
      row.className = 'im-quote-products__item';
      row.setAttribute('data-im-quote-key', key);
      row.setAttribute('data-im-quote-handle', item.productHandle || '');
      if (item.variantId !== null) {
        row.setAttribute('data-im-quote-variant-id', String(item.variantId));
      }

      if (item.image) {
        const img = document.createElement('img');
        img.className = 'im-quote-products__thumb';
        img.src = item.image;
        img.alt = item.productTitle || 'Selected product';
        img.width = 100;
        img.height = 100;
        img.loading = 'lazy';
        row.appendChild(img);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'im-quote-products__thumb-placeholder';
        placeholder.textContent = 'No image';
        row.appendChild(placeholder);
      }

      const meta = document.createElement('div');
      meta.className = 'im-quote-products__meta';

      const title = document.createElement('p');
      title.className = 'im-quote-products__title';
      title.textContent = item.productTitle || 'Product';
      title.title = item.productTitle || 'Product';
      meta.appendChild(title);

      const basePrice = getQuotePriceForHandle(item.productHandle);
      if (basePrice > 0) {
        const pricingDiv = document.createElement('div');
        pricingDiv.className = 'im-quote-products__pricing';
        pricingDiv.setAttribute('data-im-quote-pricing', key);
        pricingDiv.setAttribute('data-im-quote-pricing-handle', item.productHandle || '');
        const unitSpan = document.createElement('span');
        unitSpan.setAttribute('data-im-qp-unit', '');
        pricingDiv.appendChild(unitSpan);
        const totalSpan = document.createElement('span');
        totalSpan.className = 'im-quote-products__pricing-total';
        totalSpan.setAttribute('data-im-qp-total', '');
        pricingDiv.appendChild(totalSpan);
        meta.appendChild(pricingDiv);
        updateQuotePricingNode(pricingDiv, item.productHandle, clampQuantity(item.quantity));
      }

      const detailsLane = document.createElement('div');
      detailsLane.className = 'im-quote-products__lane';

      const meaningfulVariantTitles = Array.from(
        new Set(
          variantOptions
            .map((option) => normalizeVariantTitle(option && option.title ? option.title : ''))
            .filter(Boolean)
        )
      );
      const hasSelectableVariants = meaningfulVariantTitles.length > 1;

      if (hasSelectableVariants) {
        const variantWrap = document.createElement('div');
        variantWrap.className = 'im-quote-products__variant-select-wrap';

        const variantSelect = document.createElement('select');
        variantSelect.className = 'im-quote-products__variant-select';
        variantSelect.setAttribute('data-im-quote-variant-select', '');
        variantSelect.setAttribute('aria-label', `Color for ${item.productTitle || 'product'}`);

        variantOptions.forEach((variantOption) => {
          const optionNode = document.createElement('option');
          optionNode.value = String(variantOption.id);
          const optionLabel = variantOption.title || 'Default';
          const optionWithAvailability =
            variantOption.available === false ? `${optionLabel} (Unavailable)` : optionLabel;
          optionNode.textContent = truncateText(optionWithAvailability, 40);
          optionNode.title = optionWithAvailability;
          if (item.variantId === variantOption.id) {
            optionNode.selected = true;
          }
          variantSelect.appendChild(optionNode);
        });

        variantWrap.appendChild(variantSelect);
        detailsLane.appendChild(variantWrap);
      } else {
        const staticVariantTitle = normalizeVariantTitle(item.variantTitle || '');
        if (staticVariantTitle) {
          const variant = document.createElement('p');
          variant.className = 'im-quote-products__variant im-quote-products__variant--static';
          variant.textContent = truncateText(staticVariantTitle, 34);
          variant.title = staticVariantTitle;
          detailsLane.appendChild(variant);
        } else {
          detailsLane.classList.add('is-qty-only');
        }
      }

      const qtyRow = document.createElement('div');
      qtyRow.className = 'im-quote-products__qty-row';

      const qtyDec = document.createElement('button');
      qtyDec.type = 'button';
      qtyDec.className = 'im-quote-products__qty-step';
      qtyDec.textContent = '-';
      qtyDec.setAttribute('data-im-quote-qty-dec', '');
      qtyDec.setAttribute('aria-label', `Decrease quantity for ${item.productTitle || 'product'}`);
      qtyRow.appendChild(qtyDec);

      const qtyInput = document.createElement('input');
      qtyInput.className = 'im-quote-products__qty';
      qtyInput.type = 'number';
      qtyInput.min = '1';
      qtyInput.max = '99999';
      qtyInput.step = '1';
      qtyInput.value = String(clampQuantity(item.quantity));
      qtyInput.id = `im-quote-qty-${quoteItemDomKey(item)}`;
      qtyInput.inputMode = 'numeric';
      qtyInput.pattern = '[0-9]*';
      qtyInput.autocomplete = 'off';
      qtyInput.setAttribute('aria-label', `Quantity for ${item.productTitle || 'product'}`);
      qtyInput.setAttribute('data-im-quote-qty', '');
      qtyRow.appendChild(qtyInput);

      const qtyInc = document.createElement('button');
      qtyInc.type = 'button';
      qtyInc.className = 'im-quote-products__qty-step';
      qtyInc.textContent = '+';
      qtyInc.setAttribute('data-im-quote-qty-inc', '');
      qtyInc.setAttribute('aria-label', `Increase quantity for ${item.productTitle || 'product'}`);
      qtyRow.appendChild(qtyInc);

      detailsLane.appendChild(qtyRow);
      meta.appendChild(detailsLane);
      row.appendChild(meta);

      const removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'im-quote-products__remove im-quote-products__remove--icon im-quote-products__remove--corner';
      removeButton.textContent = '×';
      removeButton.setAttribute(
        'aria-label',
        `Remove ${item.variantTitle || 'selected'} variant from ${item.productTitle || 'product'}`
      );
      removeButton.setAttribute('data-im-quote-remove', '');
      row.appendChild(removeButton);
      quoteProductsContainer.appendChild(row);
    });

    if (hasItemMutation) {
      saveQuoteItems();
    }
    syncQuoteProductsPayload();
    updateScrollHintState(quoteProductsContainer);

  };

  const isSampleWizardEnabled = () =>
    !!(
      sampleModal &&
      sampleForm &&
      sampleWizardSteps.length === SAMPLE_WIZARD_TOTAL_STEPS &&
      sampleWizardProgress &&
      sampleWizardProgressFill &&
      sampleWizardBackButton &&
      sampleWizardNextButton &&
      sampleWizardSubmitButton
    );

  const hideSampleLinesError = () => {
    if (!sampleLinesError) return;
    sampleLinesError.hidden = true;
    sampleLinesError.textContent = '';
  };

  const showSampleLinesError = (message) => {
    if (!sampleLinesError) return;
    sampleLinesError.hidden = false;
    sampleLinesError.textContent = String(message || '').trim();
  };

  const setSampleRegionRequirement = () => {
    if (!sampleCountryField || !sampleRegionField) return;
    const countryValue = normalizeToken(getFieldValue(sampleCountryField));
    const isRequired = SAMPLE_REGION_REQUIRED_COUNTRIES.has(countryValue);
    sampleRegionField.required = isRequired;
    sampleRegionField.toggleAttribute('aria-required', isRequired);
    if (sampleRegionLabel) {
      sampleRegionLabel.textContent = isRequired ? 'State / Province *' : 'State / Province (US/CA only)';
    }
    if (!isRequired) {
      clearFieldError(sampleRegionField);
    }
  };

  const getSampleStepFields = (stepNumber) => {
    const stepNode = sampleWizardSteps[stepNumber - 1];
    if (!stepNode) return [];
    return Array.from(stepNode.querySelectorAll('input, select, textarea')).filter(
      (field) => field.type !== 'hidden'
    );
  };

  const validateSampleStepOne = (options = {}) => {
    const focusInvalid = options.focusInvalid !== false;
    hideSampleLinesError();
    if (!state.sampleItems.length) {
      showSampleLinesError('Add at least one sample before continuing.');
      if (focusInvalid && sampleSearchInput && typeof sampleSearchInput.focus === 'function') {
        sampleSearchInput.focus();
      }
      return { valid: false, firstInvalid: sampleSearchInput || sampleLinesContainer || null };
    }

    const totalUnits = getSampleTotalUnits();
    const maxUnits = getSampleMaxUnits();
    if (totalUnits > maxUnits) {
      showSampleLinesError(`For more than ${maxUnits} samples, please contact us at info@isinmaterials.com`);
      if (focusInvalid && sampleLinesContainer && typeof sampleLinesContainer.focus === 'function') {
        sampleLinesContainer.focus();
      }
      return { valid: false, firstInvalid: sampleLinesContainer || null };
    }

    return { valid: true, firstInvalid: null };
  };

  const validateSampleStepTwo = (options = {}) => {
    const focusInvalid = options.focusInvalid !== false;
    setSampleRegionRequirement();
    let firstInvalid = null;
    getSampleStepFields(2).forEach((field) => {
      const valid = validateField(field);
      if (!valid && !firstInvalid) firstInvalid = field;
    });

    if (focusInvalid && firstInvalid && typeof firstInvalid.focus === 'function') {
      firstInvalid.focus();
    }
    return { valid: !firstInvalid, firstInvalid };
  };

  const validateAllSampleSteps = () => {
    const stepOne = validateSampleStepOne({ focusInvalid: false });
    if (!stepOne.valid) return { valid: false, step: 1, firstInvalid: stepOne.firstInvalid };
    const stepTwo = validateSampleStepTwo({ focusInvalid: false });
    if (!stepTwo.valid) return { valid: false, step: 2, firstInvalid: stepTwo.firstInvalid };
    return { valid: true, step: null, firstInvalid: null };
  };

  const updateSampleWizardNav = () => {
    if (!isSampleWizardEnabled()) return;
    const currentStep = state.sampleWizardStep;
    sampleModal.setAttribute('data-im-sample-step', String(currentStep));
    if (sampleModalTitleNode) {
      sampleModalTitleNode.textContent =
        currentStep === SAMPLE_WIZARD_TOTAL_STEPS ? SAMPLE_MODAL_STEP_TWO_TITLE : SAMPLE_MODAL_STEP_ONE_TITLE;
    }
    if (sampleModalDescriptionNode) {
      sampleModalDescriptionNode.hidden = false;
      sampleModalDescriptionNode.setAttribute(
        'aria-hidden',
        currentStep === SAMPLE_WIZARD_TOTAL_STEPS ? 'true' : 'false'
      );
    }
    sampleWizardProgress.textContent = buildStepDotsLabel(currentStep, SAMPLE_WIZARD_TOTAL_STEPS);
    sampleWizardProgress.setAttribute(
      'aria-label',
      `Step ${currentStep} of ${SAMPLE_WIZARD_TOTAL_STEPS}`
    );
    if (sampleWizardProgressFill) {
      sampleWizardProgressFill.style.width = `${(currentStep / SAMPLE_WIZARD_TOTAL_STEPS) * 100}%`;
    }
    sampleWizardBackButton.hidden = currentStep === 1;
    sampleWizardNextButton.hidden = currentStep === SAMPLE_WIZARD_TOTAL_STEPS;
    sampleWizardSubmitButton.hidden = currentStep !== SAMPLE_WIZARD_TOTAL_STEPS;
  };

  const setSampleWizardStep = (step, options = {}) => {
    if (!isSampleWizardEnabled()) return;
    const requested = Number(step);
    const nextStep = Math.max(
      1,
      Math.min(SAMPLE_WIZARD_TOTAL_STEPS, Number.isFinite(requested) ? Math.round(requested) : 1)
    );
    state.sampleWizardStep = nextStep;
    sampleWizardSteps.forEach((stepNode, index) => {
      const active = index + 1 === nextStep;
      stepNode.classList.toggle('is-active', active);
      stepNode.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    updateSampleWizardNav();
    if (options.scrollToTop !== false) {
      const scrollHost = sampleModalBody || sampleModalPanel;
      if (scrollHost && typeof scrollHost.scrollTo === 'function') {
        scrollHost.scrollTo({ top: 0, behavior: 'auto' });
      }
    }
    if (options.focusFirstField) {
      const stepFields = getSampleStepFields(nextStep);
      const firstField = stepFields[0];
      if (firstField && typeof firstField.focus === 'function') {
        window.requestAnimationFrame(() => firstField.focus({ preventScroll: true }));
      }
    }
  };

  const bindSampleSummaryCollapsibles = () => {
    if (!sampleSummaryCollapsibles.length) return;
    sampleSummaryCollapsibles.forEach((detailsNode) => {
      if (!detailsNode || detailsNode.dataset.imSummaryCollapsibleBound === 'true') return;
      detailsNode.dataset.imSummaryCollapsibleBound = 'true';
      const summaryNode = detailsNode.querySelector('summary');
      if (!summaryNode) return;

      summaryNode.addEventListener('click', () => {
        if (!isMobileViewport()) return;
        detailsNode.dataset.imSummaryTop = String(summaryNode.getBoundingClientRect().top);
      });

      detailsNode.addEventListener('toggle', () => {
        if (!isMobileViewport()) return;
        const startTop = Number(detailsNode.dataset.imSummaryTop || NaN);
        if (!Number.isFinite(startTop)) return;
        const currentSummary = detailsNode.querySelector('summary');
        if (!currentSummary) return;
        const delta = currentSummary.getBoundingClientRect().top - startTop;
        if (Math.abs(delta) < 1) return;
        const scrollHost = sampleModalBody || sampleModalPanel;
        if (scrollHost && typeof scrollHost.scrollBy === 'function') {
          scrollHost.scrollBy({ top: delta, behavior: 'auto' });
        }
      });
    });
  };

  const buildSampleItem = (rawItem) => {
    if (!rawItem || typeof rawItem !== 'object') return null;
    const productHandle = String(rawItem.productHandle || '').trim();
    const productTitle = String(rawItem.productTitle || '').trim();
    if (!productHandle || !productTitle) return null;

    const quantity = clampSampleQuantity(rawItem.quantity || 1);
    const availableVariants = getSampleVariantOptionsForHandle(productHandle);
    const hasChoices = hasSampleVariantChoices(productHandle);
    const requestedVariantId = toNumber(rawItem.variantId);
    const matchedRequestedVariant =
      requestedVariantId === null
        ? null
        : availableVariants.find((variant) => variant.id === requestedVariantId) || null;
    const singleVariant = availableVariants.length === 1 ? availableVariants[0] : null;

    let variantId = requestedVariantId;
    let variantTitle = normalizeVariantTitle(rawItem.variantTitle || '');

    if (singleVariant) {
      variantId = singleVariant.id;
      variantTitle = singleVariant.title || '';
    } else if (!hasChoices) {
      variantId = matchedRequestedVariant ? matchedRequestedVariant.id : null;
      variantTitle = matchedRequestedVariant ? matchedRequestedVariant.title || '' : '';
    } else if (matchedRequestedVariant) {
      variantId = matchedRequestedVariant.id;
      variantTitle = matchedRequestedVariant.title || '';
    } else if (requestedVariantId === null) {
      variantId = null;
      variantTitle = SAMPLE_ANY_VARIANT_LABEL;
    }

    return {
      lineId: rawItem.lineId || nextSampleLineId(),
      productId: toNumber(rawItem.productId),
      productHandle,
      productTitle,
      productImage: extractImageSrc(rawItem.productImage || rawItem.image || ''),
      variantId,
      variantTitle,
      quantity,
    };
  };

  const setSampleItems = (items) => {
    state.sampleItems = Array.isArray(items) ? items.map((item) => buildSampleItem(item)).filter(Boolean) : [];
    renderSampleLines();
    renderSampleSummary();
    refreshSampleSearchResults();
    if (state.sampleItems.length) hideSampleLinesError();
  };

  const addSampleItem = (item, options = {}) => {
    const normalizedItem = buildSampleItem(item);
    if (!normalizedItem) return { ok: false, reason: 'invalid-item' };

    const maxUnits = getSampleMaxUnits();
    const totalUnits = getSampleTotalUnits();
    const remainingUnits = Math.max(0, maxUnits - totalUnits);
    if (!remainingUnits) {
      if (options.silent !== true) {
        showSampleStatus(`For more than ${maxUnits} samples, please contact us at info@isinmaterials.com`, 'warning');
      }
      return { ok: false, reason: 'max-units-reached' };
    }

    const requestedQty = clampSampleQuantity(normalizedItem.quantity);
    const qtyToAdd = Math.min(requestedQty, remainingUnits);
    const itemKey = getSampleItemKey(normalizedItem);
    const existingIndex = state.sampleItems.findIndex((entry) => getSampleItemKey(entry) === itemKey);

    if (existingIndex > -1) {
      state.sampleItems[existingIndex] = {
        ...state.sampleItems[existingIndex],
        quantity: clampSampleQuantity(state.sampleItems[existingIndex].quantity + qtyToAdd),
      };
    } else {
      state.sampleItems.push({
        ...normalizedItem,
        quantity: qtyToAdd,
      });
    }

    renderSampleLines();
    renderSampleSummary();
    refreshSampleSearchResults();
    hideSampleLinesError();

    if (qtyToAdd < requestedQty && options.silent !== true) {
      showSampleStatus(`For more than ${maxUnits} samples, please contact us at info@isinmaterials.com`, 'warning');
    } else if (options.silent !== true) {
      showSampleStatus('Sample added.', 'success');
    }

    return { ok: true };
  };

  const removeSampleItem = (lineId) => {
    const nextItems = state.sampleItems.filter((item) => item.lineId !== lineId);
    if (nextItems.length === state.sampleItems.length) return;
    setSampleItems(nextItems);
  };

  const updateSampleItemQuantity = (lineId, quantity, options = {}) => {
    const index = state.sampleItems.findIndex((item) => item.lineId === lineId);
    if (index < 0) return { ok: false, reason: 'missing-item' };
    const current = state.sampleItems[index];
    const normalizedQuantity = clampSampleQuantity(quantity);
    const totalWithoutCurrent = getSampleTotalUnits() - clampSampleQuantity(current.quantity);
    const maxForLine = Math.max(1, getSampleMaxUnits() - totalWithoutCurrent);
    const constrainedQuantity = Math.min(maxForLine, normalizedQuantity);

    state.sampleItems[index] = {
      ...current,
      quantity: constrainedQuantity,
    };
    renderSampleLines();
    renderSampleSummary();
    refreshSampleSearchResults();

    if (normalizedQuantity > constrainedQuantity && options.silent !== true) {
      showSampleStatus(`For more than ${getSampleMaxUnits()} samples, please contact us at info@isinmaterials.com`, 'warning');
    }
    return { ok: true, quantity: constrainedQuantity };
  };

  const updateSampleItemVariant = (lineId, variantToken) => {
    const itemIndex = state.sampleItems.findIndex((item) => item.lineId === lineId);
    if (itemIndex < 0) return { ok: false, reason: 'missing-item' };
    const item = state.sampleItems[itemIndex];
    const hasChoices = hasSampleVariantChoices(item.productHandle);

    if (hasChoices && (variantToken === SAMPLE_ANY_VARIANT_VALUE || variantToken === '')) {
      state.sampleItems[itemIndex] = {
        ...item,
        variantId: null,
        variantTitle: SAMPLE_ANY_VARIANT_LABEL,
      };
      renderSampleLines();
      renderSampleSummary();
      refreshSampleSearchResults();
      return { ok: true };
    }

    const variantId = toNumber(variantToken);
    const selectedVariant = getSampleVariantForHandle(item.productHandle, variantId);
    if (!selectedVariant) return { ok: false, reason: 'invalid-variant' };

    const duplicate = state.sampleItems.find(
      (entry) =>
        entry.lineId !== lineId &&
        String(entry.productHandle || '').trim() === String(item.productHandle || '').trim() &&
        toNumber(entry.variantId) === selectedVariant.id
    );
    if (duplicate) {
      showSampleStatus('This variant is already in your summary. Increase quantity there.', 'warning');
      return { ok: false, reason: 'duplicate-variant' };
    }

    state.sampleItems[itemIndex] = {
      ...item,
      variantId: selectedVariant.id,
      variantTitle: selectedVariant.title || '',
    };
    renderSampleLines();
    renderSampleSummary();
    refreshSampleSearchResults();
    return { ok: true };
  };

  const renderSampleLines = () => {
    if (!sampleLinesContainer) return;
    sampleLinesContainer.innerHTML = '';

    if (!state.sampleItems.length) {
      const empty = document.createElement('p');
      empty.className = 'im-sample-lines__empty';
      empty.textContent = 'No samples selected yet. Search products above and add your first sample.';
      sampleLinesContainer.appendChild(empty);
      updateScrollHintState(sampleLinesContainer);
      return;
    }

    const unitPriceCents = getSampleUnitPriceCents();
    let hasItemMutation = false;
    state.sampleItems.forEach((item) => {
      const variantOptions = getSampleVariantOptionsForHandle(item.productHandle);
      const hasChoices = hasSampleVariantChoices(item.productHandle);
      const onlyVariant = variantOptions.length === 1 ? variantOptions[0] : null;

      if (onlyVariant && toNumber(item.variantId) !== onlyVariant.id) {
        item.variantId = onlyVariant.id;
        item.variantTitle = onlyVariant.title || '';
        hasItemMutation = true;
      } else if (!hasChoices && !onlyVariant && toNumber(item.variantId) === null && item.variantTitle === SAMPLE_ANY_VARIANT_LABEL) {
        item.variantTitle = '';
        hasItemMutation = true;
      }

      const row = document.createElement('article');
      row.className = 'im-sample-line';
      row.setAttribute('data-im-sample-line-id', item.lineId);

      const thumbSrc = getSampleItemImage(item);
      if (thumbSrc) {
        const image = document.createElement('img');
        image.className = 'im-sample-line__thumb';
        image.src = thumbSrc;
        image.alt = item.productTitle || 'Selected sample';
        image.width = 84;
        image.height = 84;
        image.loading = 'lazy';
        row.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'im-sample-line__thumb-placeholder';
        placeholder.textContent = 'No image';
        row.appendChild(placeholder);
      }

      const meta = document.createElement('div');
      meta.className = 'im-sample-line__meta';

      const title = document.createElement('p');
      title.className = 'im-sample-line__title';
      title.textContent = item.productTitle || 'Sample';
      title.title = item.productTitle || 'Sample';
      meta.appendChild(title);

      if (hasChoices) {
        const variantWrap = document.createElement('label');
        variantWrap.className = 'im-sample-line__variant-wrap';
        variantWrap.setAttribute('aria-label', `Variant preference for ${item.productTitle || 'sample'}`);

        const variantSelect = document.createElement('select');
        variantSelect.className = 'im-sample-line__variant';
        variantSelect.setAttribute('data-im-sample-variant-select', '');
        variantSelect.setAttribute('aria-label', `Variant preference for ${item.productTitle || 'sample'}`);

        const anyOption = document.createElement('option');
        anyOption.value = SAMPLE_ANY_VARIANT_VALUE;
        anyOption.textContent = SAMPLE_ANY_VARIANT_LABEL;
        if (toNumber(item.variantId) === null) anyOption.selected = true;
        variantSelect.appendChild(anyOption);

        variantOptions.forEach((variantOption) => {
          const option = document.createElement('option');
          option.value = String(variantOption.id);
          option.textContent = variantOption.title || 'Variant';
          if (toNumber(item.variantId) === variantOption.id) {
            option.selected = true;
          }
          variantSelect.appendChild(option);
        });

        variantWrap.appendChild(variantSelect);
        meta.appendChild(variantWrap);
      } else if (onlyVariant && normalizeVariantTitle(onlyVariant.title || '')) {
        const variantStatic = document.createElement('p');
        variantStatic.className = 'im-sample-line__variant-static';
        variantStatic.textContent = onlyVariant.title;
        meta.appendChild(variantStatic);
      }

      const controls = document.createElement('div');
      controls.className = 'im-sample-line__controls';

      const qtyRow = document.createElement('div');
      qtyRow.className = 'im-sample-line__qty-row';

      const dec = document.createElement('button');
      dec.type = 'button';
      dec.className = 'im-sample-line__qty-step';
      dec.textContent = '-';
      dec.setAttribute('data-im-sample-qty-dec', '');
      dec.setAttribute('aria-label', `Decrease quantity for ${item.productTitle || 'sample'}`);
      qtyRow.appendChild(dec);

      const qtyInput = document.createElement('input');
      qtyInput.type = 'number';
      qtyInput.className = 'im-sample-line__qty';
      qtyInput.min = '1';
      qtyInput.max = String(getSampleMaxUnits());
      qtyInput.step = '1';
      qtyInput.inputMode = 'numeric';
      qtyInput.pattern = '[0-9]*';
      qtyInput.value = String(clampSampleQuantity(item.quantity));
      qtyInput.setAttribute('data-im-sample-qty', '');
      qtyInput.setAttribute('aria-label', `Quantity for ${item.productTitle || 'sample'}`);
      qtyRow.appendChild(qtyInput);

      const inc = document.createElement('button');
      inc.type = 'button';
      inc.className = 'im-sample-line__qty-step';
      inc.textContent = '+';
      inc.setAttribute('data-im-sample-qty-inc', '');
      inc.setAttribute('aria-label', `Increase quantity for ${item.productTitle || 'sample'}`);
      qtyRow.appendChild(inc);
      controls.appendChild(qtyRow);

      const linePrice = document.createElement('p');
      linePrice.className = 'im-sample-line__line-price';
      linePrice.textContent = formatSampleMoney(clampSampleQuantity(item.quantity) * unitPriceCents);
      controls.appendChild(linePrice);

      meta.appendChild(controls);
      row.appendChild(meta);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'im-sample-line__remove';
      remove.textContent = '×';
      remove.setAttribute('data-im-sample-remove', '');
      remove.setAttribute('aria-label', `Remove ${item.productTitle || 'sample'}`);
      row.appendChild(remove);

      sampleLinesContainer.appendChild(row);
    });

    if (hasItemMutation) {
      renderSampleSummary();
    }
    updateScrollHintState(sampleLinesContainer);
  };

  const renderSampleSummary = () => {
    const unitPrice = getSampleUnitPriceCents();
    const subtotalCents = getSampleSubtotalCents();
    const totalUnits = getSampleTotalUnits();
    const currencyCode = getSampleCurrency();

    sampleUnitPriceNodes.forEach((node) => {
      node.textContent = formatSampleMoney(unitPrice);
    });
    sampleCurrencyNodes.forEach((node) => {
      node.textContent = currencyCode;
    });
    sampleSubtotalNodes.forEach((node) => {
      node.textContent = formatSampleMoney(subtotalCents);
    });
    sampleTotalTodayNodes.forEach((node) => {
      node.textContent = formatSampleMoney(subtotalCents);
    });
    sampleQtyTotalNodes.forEach((node) => {
      node.textContent = String(totalUnits);
    });

    sampleSummaryItemContainers.forEach((container) => {
      container.innerHTML = '';
      if (!state.sampleItems.length) {
        const empty = document.createElement('p');
        empty.className = 'im-sample-summary__empty';
        empty.textContent = 'No samples selected yet.';
        container.appendChild(empty);
        return;
      }

      state.sampleItems.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'im-sample-summary__item';

        const title = document.createElement('p');
        title.className = 'im-sample-summary__item-title';
        title.textContent = item.productTitle || 'Sample';
        row.appendChild(title);

        const meta = document.createElement('p');
        meta.className = 'im-sample-summary__item-meta';
        const hasChoices = hasSampleVariantChoices(item.productHandle);
        const normalizedVariantTitle = normalizeVariantTitle(item.variantTitle || '');
        const variantLabel =
          toNumber(item.variantId) === null
            ? (hasChoices ? SAMPLE_ANY_VARIANT_LABEL : '')
            : (normalizedVariantTitle || (hasChoices ? 'Variant' : ''));
        meta.textContent = variantLabel
          ? `${variantLabel} · Qty ${clampSampleQuantity(item.quantity)}`
          : `Qty ${clampSampleQuantity(item.quantity)}`;
        row.appendChild(meta);

        const lineTotal = document.createElement('p');
        lineTotal.className = 'im-sample-summary__item-price';
        lineTotal.textContent = formatSampleMoney(clampSampleQuantity(item.quantity) * unitPrice);
        row.appendChild(lineTotal);

        container.appendChild(row);
      });
    });
  };

  const renderSampleSearchMessage = (message) => {
    if (!sampleSearchResults) return;
    sampleSearchResults.innerHTML = '';
    const node = document.createElement('p');
    node.className = 'im-sample-picker__message';
    node.textContent = message;
    sampleSearchResults.appendChild(node);
    updateScrollHintState(sampleSearchResults);
  };

  const filterSampleCatalogEntries = (query) => {
    const source = getSampleEligibleCatalogProducts();
    if (!source.length) return [];
    const normalizedQuery = normalizeLabel(query);
    const terms = normalizedQuery ? normalizedQuery.split(' ').filter(Boolean) : [];

    return source
      .filter((product) => {
        if (!terms.length) return true;
        return terms.every((term) => product.searchText.includes(term));
      })
      .slice(0, PRODUCT_CATALOG_RESULTS_LIMIT)
      .map((product) => {
        const matchedVariant = getMatchingVariantForTerms(product, terms);
        return {
          ...product,
          matchedVariantId: matchedVariant ? matchedVariant.id : null,
          matchedVariantTitle: matchedVariant
            ? (matchedVariant.colorLabel ||
              (Array.isArray(matchedVariant.optionValues) ? matchedVariant.optionValues[0] : '') ||
              normalizeVariantTitle(matchedVariant.title || ''))
            : '',
          image: matchedVariant && matchedVariant.image ? matchedVariant.image : product.image,
        };
      });
  };

  const renderSampleSearchResults = (items) => {
    if (!sampleSearchResults) return;
    sampleSearchResults.innerHTML = '';
    const disableAdd = getSampleTotalUnits() >= getSampleMaxUnits();

    items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'im-sample-picker__result';

      const lead = document.createElement('div');
      lead.className = 'im-sample-picker__result-lead';

      if (item.image) {
        const thumb = document.createElement('img');
        thumb.className = 'im-sample-picker__result-thumb';
        thumb.src = item.image;
        thumb.alt = item.productTitle || 'Product';
        thumb.width = 52;
        thumb.height = 52;
        thumb.loading = 'lazy';
        lead.appendChild(thumb);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'im-sample-picker__result-thumb-placeholder';
        placeholder.textContent = 'No image';
        lead.appendChild(placeholder);
      }

      const meta = document.createElement('div');
      meta.className = 'im-sample-picker__result-meta';

      const name = document.createElement('p');
      name.className = 'im-sample-picker__result-name';
      name.textContent = item.productTitle || item.productHandle || 'Product';
      meta.appendChild(name);

      const helper = document.createElement('p');
      helper.className = 'im-sample-picker__result-helper';
      const variantText = String(item.matchedVariantTitle || '').trim();
      helper.textContent = variantText
        ? `Match: ${truncateText(variantText, 28)} · Fee ${formatSampleMoney(getSampleUnitPriceCents())} per unit`
        : `Fee ${formatSampleMoney(getSampleUnitPriceCents())} per unit`;
      meta.appendChild(helper);

      lead.appendChild(meta);
      row.appendChild(lead);

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'im-sample-picker__result-add';
      add.textContent = getSampleAddLabel();
      add.disabled = disableAdd;
      add.setAttribute('data-im-sample-search-add', '');
      add.setAttribute('data-im-sample-handle', item.productHandle || '');
      add.setAttribute('data-im-sample-title', item.productTitle || '');
      add.setAttribute('data-im-sample-product-id', item.productId ? String(item.productId) : '');
      add.setAttribute(
        'data-im-sample-preferred-variant-id',
        item.matchedVariantId ? String(item.matchedVariantId) : ''
      );
      row.appendChild(add);

      sampleSearchResults.appendChild(row);
    });
    updateScrollHintState(sampleSearchResults);
  };

  const addProductByHandleToSampleList = async (handle, productHint = {}, options = {}) => {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return { ok: false, reason: 'missing-handle' };

    if (getSampleTotalUnits() >= getSampleMaxUnits()) {
      if (options.silent !== true) {
        showSampleStatus(`Maximum ${getSampleMaxUnits()} units allowed per request.`, 'warning');
      }
      return { ok: false, reason: 'max-units-reached' };
    }

    let product = null;
    try {
      product = await fetchProductDetailsForQuote(normalizedHandle);
    } catch (error) {
      if (options.silent !== true) {
        showSampleStatus('Could not add this product right now. Please try again.', 'warning');
      }
      return { ok: false, reason: 'fetch-failed' };
    }
    if (!product) return { ok: false, reason: 'missing-product' };

    const productImage = extractImageSrc(
      product.featured_image ||
        (Array.isArray(product.images) ? product.images[0] : '') ||
        productHint.image
    );

    const variantOptions = getSampleVariantOptionsForHandle(product.handle || normalizedHandle);
    const hasChoices = hasSampleVariantChoices(product.handle || normalizedHandle);
    const preferredVariantId = toNumber(
      options.preferredVariantId || productHint.preferredVariantId || productHint.matchedVariantId
    );
    const preferredVariant =
      preferredVariantId !== null
        ? variantOptions.find((variant) => variant.id === preferredVariantId) || null
        : null;
    const singleVariant = variantOptions.length === 1 ? variantOptions[0] : null;

    const initialVariantId = singleVariant
      ? singleVariant.id
      : (preferredVariant ? preferredVariant.id : null);
    const initialVariantTitle = singleVariant
      ? (singleVariant.title || '')
      : (preferredVariant ? (preferredVariant.title || '') : (hasChoices ? SAMPLE_ANY_VARIANT_LABEL : ''));

    const result = addSampleItem(
      {
        productId: toNumber(product.id || productHint.productId),
        productHandle: product.handle || normalizedHandle,
        productTitle: product.title || productHint.productTitle || normalizedHandle,
        productImage,
        variantId: initialVariantId,
        variantTitle: initialVariantTitle,
        quantity: 1,
      },
      options
    );
    if (result.ok && isSampleEligibilityFallback()) {
      showSampleStatus(
        'No explicit sample-eligible tags were found, so all products are currently searchable.',
        'info'
      );
    }
    return result;
  };

  const addCurrentProductToSampleList = async (options = {}) => {
    if (!state.productHandle) return { ok: false, reason: 'missing-current-product' };
    return addProductByHandleToSampleList(
      state.productHandle,
      {
        productId: state.productId,
        productTitle: state.productTitle,
        image: state.productImage,
      },
      options
    );
  };

  const runSampleSearch = async (query) => {
    if (!sampleSearchResults) return;
    const normalizedQuery = String(query || '').trim();

    if (!quoteCatalogLoaded && normalizedQuery.length < 2) {
      clearSampleSearchResults();
      return;
    }

    const requestId = ++sampleSearchRequestId;
    if (!quoteCatalogLoaded) {
      renderSampleSearchMessage('Loading products...');
      try {
        await loadQuoteCatalog();
      } catch (error) {
        if (requestId !== sampleSearchRequestId) return;
        renderSampleSearchMessage('Could not load products right now. Please try again.');
        return;
      }
    }
    if (requestId !== sampleSearchRequestId) return;

    const results = filterSampleCatalogEntries(normalizedQuery);
    if (!results.length) {
      renderSampleSearchMessage('No matching sample products found.');
      return;
    }
    renderSampleSearchResults(results);
  };

  const refreshSampleSearchResults = () => {
    if (!sampleSearchInput || !sampleSearchResults) return;
    const query = String(sampleSearchInput.value || '').trim();
    if (!quoteCatalogLoaded && query.length < 2) return;
    runSampleSearch(query);
  };

  const refreshSamplePricingForCurrency = () => {
    if (!sampleModal) return;
    renderSampleLines();
    renderSampleSummary();
    refreshSampleSearchResults();
  };

  const buildQuotePayload = (form) => {
    if (!form || !form.closest('[data-im-modal="quote"]')) return null;
    const currency = getQuoteCurrency();

    let subtotal = 0;
    const items = state.quoteItems.map((item) => {
      const qty = clampQuantity(item.quantity);
      const basePrice = getQuotePriceForHandle(item.productHandle);
      const tier = findQuoteVolumeTier(qty);
      const discountPercent = tier ? tier.discount : 0;
      const discountTier = tier ? tier.threshold : 0;
      // Shopify rounds discounted money up to the cent and discounts the line,
      // not the unit — mirror both so the e-mail matches the draft order.
      const unitPrice = basePrice ? ceilCents(basePrice * (1 - discountPercent / 100)) : 0;
      const lineTotal = basePrice ? ceilCents(qty * basePrice * (1 - discountPercent / 100)) : 0;
      subtotal += lineTotal;
      return {
        product_id: toNumber(item.productId),
        product_handle: item.productHandle || '',
        product_title: item.productTitle || '',
        variant_id: toNumber(item.variantId),
        variant_title: normalizeVariantTitle(item.variantTitle || ''),
        qty,
        base_price: basePrice ? Number(basePrice.toFixed(2)) : 0,
        discount_percent: discountPercent,
        discount_tier: discountTier,
        unit_price: unitPrice,
        line_total: lineTotal,
      };
    });

    const modal = form.closest('[data-im-modal="quote"]');
    const localeCountryCode = String((modal && modal.dataset.imQuoteLocaleCountry) || '').toUpperCase();
    const tagsField = form.querySelector('[data-im-autofill="quote-tags"]');
    const tagsRaw = String((tagsField && tagsField.value) || '').trim();
    const tagList = tagsRaw
      ? tagsRaw.split(',').map((tag) => tag.trim()).filter(Boolean)
      : ['project_inquiry', 'quote'];
    const submissionId = String(form.dataset.imSubmissionId || '').trim();

    return {
      type: 'quote_request',
      currency,
      items,
      subtotal: Number(subtotal.toFixed(2)),
      submission_id: submissionId,
      country_code: localeCountryCode,
      tags: tagList,
      contact: {
        first_name: getFieldValue(form.querySelector('[data-im-field="first_name"]')),
        last_name: getFieldValue(form.querySelector('[data-im-field="last_name"]')),
        email: getFieldValue(form.querySelector('[data-im-field="email"]')),
        phone: getFieldValue(form.querySelector('[data-im-field="phone"]')),
        company: getFieldValue(form.querySelector('[data-im-field="company"]')),
        position: getFieldValue(form.querySelector('[data-im-field="position"]')),
        vat_number: getFieldValue(form.querySelector('[data-im-field="vat_number"]')),
      },
      delivery_address: {
        country: getFieldValue(form.querySelector('[data-im-field="country"]')),
        city: getFieldValue(form.querySelector('[data-im-field="city"]')),
        postal_code: getFieldValue(form.querySelector('[data-im-field="postal_code"]')),
      },
      project: {
        project_type: getFieldValue(form.querySelector('[data-im-field="project_type"]')),
        timeline: getFieldValue(form.querySelector('[data-im-field="timeline"]')),
        message: getFieldValue(form.querySelector('[data-im-field="project_message"]')),
      },
    };
  };

  const buildSamplePayload = (form) => {
    if (!form || !form.closest('[data-im-modal="sample"]')) return null;
    const currency = getSampleCurrency();
    const unitPriceCents = getSampleUnitPriceCents();
    const unitPrice = Number((unitPriceCents / 100).toFixed(2));

    const samples = state.sampleItems.map((item) => {
      const qty = clampSampleQuantity(item.quantity);
      const explicitVariantId = toNumber(item.variantId);
      const hasChoices = hasSampleVariantChoices(item.productHandle);
      const normalizedVariantTitle = normalizeVariantTitle(item.variantTitle || '');
      // When the user accepted "Any" (or no variant was picked), fall back to
      // the product's first known variant so the draft order line stays linked
      // to a real Shopify product (image, SKU, link). The variant_title still
      // reads "Any" so the merchant sees the user's original intent in the note.
      // Use the unfiltered variant list as a final fallback so single-variant
      // products (Shopify's auto-generated "Default Title") still get linked.
      const fallbackVariant =
        explicitVariantId === null
          ? (getSampleVariantOptionsForHandle(item.productHandle)[0]
              || getVariantOptionsForHandle(item.productHandle)[0]
              || null)
          : null;
      const resolvedVariantId =
        explicitVariantId !== null
          ? explicitVariantId
          : (fallbackVariant ? toNumber(fallbackVariant.id) : null);
      const variantTitle =
        explicitVariantId === null
          ? (hasChoices ? 'Any' : '')
          : (normalizedVariantTitle || (hasChoices ? SAMPLE_ANY_VARIANT_LABEL : ''));
      return {
        product_id: toNumber(item.productId),
        product_title: item.productTitle || '',
        variant_id: resolvedVariantId,
        variant_title: variantTitle,
        qty,
        unit_price: unitPrice,
        line_total: Number(((qty * unitPriceCents) / 100).toFixed(2)),
      };
    });

    const subtotal = Number((getSampleSubtotalCents() / 100).toFixed(2));
    const modal = form.closest('[data-im-modal="sample"]');
    const localeCountryCode = String((modal && modal.dataset.imSampleLocaleCountry) || '').toUpperCase();
    const tagsField = form.querySelector('[data-im-autofill="sample-tags"]');
    const tagsRaw = String((tagsField && tagsField.value) || '').trim();
    const tagList = tagsRaw
      ? tagsRaw.split(',').map((tag) => tag.trim()).filter(Boolean)
      : ['sample_request', 'sample'];
    const submissionId = String(form.dataset.imSubmissionId || '').trim();

    return {
      type: 'sample_order',
      currency,
      samples,
      subtotal,
      shipping: 'quoted_by_email',
      submission_id: submissionId,
      country_code: localeCountryCode,
      tags: tagList,
      contact: {
        first_name: getFieldValue(form.querySelector('[data-im-field="first_name"]')),
        last_name: getFieldValue(form.querySelector('[data-im-field="last_name"]')),
        email: getFieldValue(form.querySelector('[data-im-field="email"]')),
        phone: getFieldValue(form.querySelector('[data-im-field="phone"]')),
        company: getFieldValue(form.querySelector('[data-im-field="company"]')),
        vat_number: getFieldValue(form.querySelector('[data-im-field="vat_number"]')),
      },
      delivery_address: {
        country: getFieldValue(form.querySelector('[data-im-field="country"]')),
        state_province: getFieldValue(form.querySelector('[data-im-field="state_province"]')),
        city: getFieldValue(form.querySelector('[data-im-field="city"]')),
        postal_code: getFieldValue(form.querySelector('[data-im-field="postal_code"]')),
        address_line_1: getFieldValue(form.querySelector('[data-im-field="address_line_1"]')),
        address_line_2: getFieldValue(form.querySelector('[data-im-field="address_line_2"]')),
      },
      notes: getFieldValue(form.querySelector('[data-im-field="delivery_notes"]')),
    };
  };

  const resetSampleWizardState = (options = {}) => {
    if (!sampleModal || !sampleForm) return;
    const clearItems = options.clearItems === true;

    sampleForm.reset();
    clearValidationErrors(sampleForm);
    hideSampleLinesError();
    showSampleStatus('', 'info');

    if (clearItems) {
      state.sampleItems = [];
    }

    if (!state.sampleItems.length && state.productHandle) {
      state.sampleItems = [
        buildSampleItem({
          productId: state.productId,
          productHandle: state.productHandle,
          productTitle: state.productTitle,
          productImage: state.productImage,
          variantId: null,
          variantTitle: SAMPLE_ANY_VARIANT_LABEL,
          quantity: 1,
        }),
      ].filter(Boolean);
    }

    if (sampleSearchInput) {
      sampleSearchInput.value = '';
    }
    clearSampleSearchResults();
    setSampleRegionRequirement();
    renderSampleLines();
    renderSampleSummary();
    setSampleWizardStep(1);
    refreshSampleSearchResults();
    sampleModal.querySelectorAll('.im-modal__feedback--success').forEach((node) => {
      node.hidden = true;
    });
    sampleModal.classList.remove('im-modal--submitted');
  };

  const initSampleWizard = () => {
    if (!isSampleWizardEnabled()) return;
    sampleModal.classList.add('im-modal--sample-ready');
    sampleForm.noValidate = true;

    if (sampleWizardFallbackSubmit) {
      sampleWizardFallbackSubmit.hidden = true;
      sampleWizardFallbackSubmit.type = 'button';
    }
    sampleWizardSubmitButton.type = 'button';

    sampleWizardSteps.forEach((stepNode, index) => {
      const isActive = index === 0;
      stepNode.classList.toggle('is-active', isActive);
      stepNode.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    if (!state.sampleItems.length && state.productHandle) {
      state.sampleItems = [
        buildSampleItem({
          productId: state.productId,
          productHandle: state.productHandle,
          productTitle: state.productTitle,
          productImage: state.productImage,
          variantId: null,
          variantTitle: SAMPLE_ANY_VARIANT_LABEL,
          quantity: 1,
        }),
      ].filter(Boolean);
    }

    renderSampleLines();
    renderSampleSummary();
    clearSampleSearchResults();
    setSampleRegionRequirement();
    bindSampleSummaryCollapsibles();
    setSampleWizardStep(1);

    sampleWizardBackButton.addEventListener('click', () => {
      setSampleWizardStep(state.sampleWizardStep - 1, { focusFirstField: true });
    });

    sampleWizardNextButton.addEventListener('click', () => {
      const stepValidation = validateSampleStepOne({ focusInvalid: true });
      if (!stepValidation.valid) return;
      setSampleWizardStep(2, { focusFirstField: false });
    });

    sampleWizardSubmitButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      submitModalWithValidation(sampleModal, sampleForm);
    });

    if (sampleCountryField) {
      sampleCountryField.addEventListener('input', setSampleRegionRequirement);
      sampleCountryField.addEventListener('change', setSampleRegionRequirement);
    }

    sampleForm.addEventListener('input', (event) => {
      const field = event.target.closest('input, select, textarea');
      if (!field) return;
      if (field.checkValidity()) clearFieldError(field);
    });

    sampleForm.addEventListener('change', (event) => {
      const field = event.target.closest('input, select, textarea');
      if (!field) return;
      if (field.checkValidity()) clearFieldError(field);
    });

    sampleForm.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (event.defaultPrevented) return;
      const target = event.target;
      if (!target || target.tagName === 'TEXTAREA') return;
      if (target === sampleSearchInput) {
        event.preventDefault();
        if (sampleSearchTimer) {
          window.clearTimeout(sampleSearchTimer);
        }
        runSampleSearch(sampleSearchInput.value || '');
        return;
      }
      event.preventDefault();
    });
  };

  const getFieldValue = (field) => {
    if (!field) return '';
    if (field.type === 'file') {
      if (!field.files || !field.files.length) return '';
      return Array.from(field.files)
        .map((file) => file.name)
        .join(', ');
    }
    if (field.type === 'checkbox') return field.checked ? 'Yes' : 'No';
    if (field.type === 'radio') {
      if (!field.form) return field.checked ? field.value : '';
      const selected = field.form.querySelector(`input[name="${field.name}"]:checked`);
      return selected ? selected.value : '';
    }
    return String(field.value || '').trim();
  };

  const pushLine = (lines, label, value) => {
    const safeValue = String(value || '').trim();
    if (!safeValue) return;
    lines.push(`${label}: ${safeValue}`);
  };

  const pushSection = (lines, title, rows) => {
    const validRows = rows.filter(Boolean);
    if (!validRows.length) return;
    if (lines.length) lines.push('');
    lines.push(title);
    validRows.forEach((row) => lines.push(row));
  };

  const buildStructuredBody = (form) => {
    const lines = [];
    const isQuoteForm = !!form.closest('[data-im-modal="quote"]');
    const submissionId = String(form.dataset.imSubmissionId || '').trim();
    const submissionTimestamp = String(form.dataset.imSubmissionTimestamp || '').trim();

    pushSection(
      lines,
      'Submission',
      [
        `Form: ${isQuoteForm ? 'Request Quote' : 'Order Samples'}`,
        submissionTimestamp ? `Submitted at (UTC): ${submissionTimestamp}` : '',
        submissionId ? `Reference: ${submissionId}` : '',
        submissionId
          ? `Shopify: draft order auto-created — Orders → Drafts, tag submission:${submissionId}`
          : '',
      ]
    );

    if (isQuoteForm) {
      const quotePayload = buildQuotePayload(form);
      const quoteCurrency = (quotePayload && quotePayload.currency) || getQuoteCurrency();

      const contactRows = [];
      const firstName = getFieldValue(form.querySelector('[data-im-field="first_name"]'));
      const lastName = getFieldValue(form.querySelector('[data-im-field="last_name"]'));
      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      pushLine(contactRows, 'Name', fullName);
      pushLine(contactRows, 'Email', getFieldValue(form.querySelector('[data-im-field="email"]')));
      pushLine(contactRows, 'Phone', getFieldValue(form.querySelector('[data-im-field="phone"]')));
      pushLine(contactRows, 'Company / Studio', getFieldValue(form.querySelector('[data-im-field="company"]')));
      pushLine(contactRows, 'Position / Role', getFieldValue(form.querySelector('[data-im-field="position"]')));
      pushLine(contactRows, 'VAT Number', getFieldValue(form.querySelector('[data-im-field="vat_number"]')));
      pushSection(lines, 'Contact', contactRows);

      const locationRows = [];
      pushLine(locationRows, 'Country', getFieldValue(form.querySelector('[data-im-field="country"]')));
      pushLine(locationRows, 'City', getFieldValue(form.querySelector('[data-im-field="city"]')));
      pushLine(locationRows, 'Postal Code', getFieldValue(form.querySelector('[data-im-field="postal_code"]')));
      pushSection(lines, 'Location', locationRows);

      const projectRows = [];
      pushLine(projectRows, 'Project Type', getFieldValue(form.querySelector('[data-im-field="project_type"]')));
      pushLine(projectRows, 'Timeline', getFieldValue(form.querySelector('[data-im-field="timeline"]')));
      pushSection(lines, 'Project Details', projectRows);

      if (quotePayload && Array.isArray(quotePayload.items) && quotePayload.items.length) {
        const productBlocks = quotePayload.items.map((item, index) => {
          const variantText = item.variant_title ? ` / ${item.variant_title}` : '';
          const rows = [`${index + 1}. ${item.product_title}${variantText}`];
          if (item.base_price > 0) {
            rows.push(`   Qty: ${formatCount(item.qty)} × ${formatQuoteMoney(item.base_price, quoteCurrency)}`);
            if (item.discount_percent > 0) {
              rows.push(
                `   Discount: Volume ${item.discount_tier}+ -${item.discount_percent}% → ${formatQuoteMoney(item.unit_price, quoteCurrency)} per unit`
              );
            }
            rows.push(`   Line total: ${formatQuoteMoney(item.line_total, quoteCurrency)}`);
          } else {
            rows.push(`   Qty: ${formatCount(item.qty)}`);
            rows.push('   Price: no metafield — quote manually');
          }
          return rows.join('\n');
        });
        // One row holding the whole list: pushSection drops empty strings, so the
        // blank lines between products have to travel inside the row itself.
        pushSection(lines, 'Quote Products', [productBlocks.join('\n\n')]);

        const totalUnits = quotePayload.items.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
        const pricingRows = [];
        pushLine(pricingRows, 'Currency', quoteCurrency);
        pushLine(
          pricingRows,
          'Products',
          `${quotePayload.items.length} (${formatCount(totalUnits)} units total)`
        );
        if (quotePayload.subtotal > 0) {
          pushLine(pricingRows, 'Subtotal after volume discount', formatQuoteMoney(quotePayload.subtotal, quoteCurrency));
        }
        pushLine(pricingRows, 'Note', 'Shipping and local taxes not included');
        pushSection(lines, 'Pricing', pricingRows);
      } else if (state.quoteItems.length) {
        const productRows = state.quoteItems.map((item, index) => {
          const variantText = item.variantTitle ? ` / ${item.variantTitle}` : '';
          return `${index + 1}. ${item.productTitle}${variantText} | Qty: ${item.quantity}`;
        });
        pushSection(lines, 'Quote Products', productRows);
      }

      pushSection(lines, 'Message', [getFieldValue(form.querySelector('[data-im-field="project_message"]'))]);
    } else {
      const payload = buildSamplePayload(form);
      const contactRows = [];
      const firstName = getFieldValue(form.querySelector('[data-im-field="first_name"]'));
      const lastName = getFieldValue(form.querySelector('[data-im-field="last_name"]'));
      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      pushLine(contactRows, 'Name', fullName);
      pushLine(contactRows, 'Email', getFieldValue(form.querySelector('[data-im-field="email"]')));
      pushLine(contactRows, 'Phone', getFieldValue(form.querySelector('[data-im-field="phone"]')));
      pushLine(contactRows, 'Company / Studio', getFieldValue(form.querySelector('[data-im-field="company"]')));
      pushLine(contactRows, 'VAT Number', getFieldValue(form.querySelector('[data-im-field="vat_number"]')));
      pushSection(lines, 'Contact', contactRows);

      const deliveryRows = [];
      pushLine(deliveryRows, 'Country', getFieldValue(form.querySelector('[data-im-field="country"]')));
      pushLine(deliveryRows, 'State / Province', getFieldValue(form.querySelector('[data-im-field="state_province"]')));
      pushLine(deliveryRows, 'City', getFieldValue(form.querySelector('[data-im-field="city"]')));
      pushLine(deliveryRows, 'Postal Code', getFieldValue(form.querySelector('[data-im-field="postal_code"]')));
      pushLine(deliveryRows, 'Address Line 1', getFieldValue(form.querySelector('[data-im-field="address_line_1"]')));
      pushLine(deliveryRows, 'Address Line 2', getFieldValue(form.querySelector('[data-im-field="address_line_2"]')));
      pushSection(lines, 'Delivery', deliveryRows);

      if (payload && Array.isArray(payload.samples) && payload.samples.length) {
        const sampleBlocks = payload.samples.map((sample, index) => {
          const variantText = sample.variant_title ? ` / ${sample.variant_title}` : '';
          return [
            `${index + 1}. ${sample.product_title}${variantText}`,
            `   Qty: ${formatCount(sample.qty)} × ${formatSampleMoney(Math.round(Number(sample.unit_price || 0) * 100))}`,
            `   Line total: ${formatSampleMoney(Math.round(Number(sample.line_total || 0) * 100))}`,
          ].join('\n');
        });
        pushSection(lines, 'Sample Request', [sampleBlocks.join('\n\n')]);
      }

      const pricingRows = [];
      pushLine(pricingRows, 'Currency', payload && payload.currency);
      pushLine(
        pricingRows,
        'Per-sample fee',
        formatSampleMoney(payload ? Math.round(Number(payload.samples?.[0]?.unit_price || getSampleUnitPriceCents() / 100) * 100) : getSampleUnitPriceCents())
      );
      pushLine(
        pricingRows,
        'Samples subtotal',
        formatSampleMoney(payload ? Math.round(Number(payload.subtotal || 0) * 100) : getSampleSubtotalCents())
      );
      pushLine(pricingRows, 'Shipping', 'Best carrier option quoted by email');
      pushLine(pricingRows, 'Invoice', 'Sent manually after review');
      pushSection(lines, 'Pricing', pricingRows);

      pushSection(lines, 'Notes', [getFieldValue(form.querySelector('[data-im-field="delivery_notes"]'))]);
    }

    return lines.join('\n');
  };

  const prepareFormPayload = (form) => {
    const submissionMeta = buildSubmissionMeta();
    form.dataset.imSubmissionId = submissionMeta.id;
    form.dataset.imSubmissionTimestamp = submissionMeta.timestampUtc;

    const firstName = getFieldValue(form.querySelector('[data-im-field="first_name"]'));
    const lastName = getFieldValue(form.querySelector('[data-im-field="last_name"]'));
    const fullName = [firstName, lastName].filter(Boolean).join(' ');

    const contactNameField = form.querySelector('[data-im-autofill="contact-name"]');
    if (contactNameField) contactNameField.value = fullName;

    const structuredBody = form.querySelector('[data-im-structured-body]');
    if (structuredBody) structuredBody.value = buildStructuredBody(form);

    syncQuoteProductsPayload();
  };

  const findModalByKey = (key) => {
    if (key === 'quote') return quoteModal;
    if (key === 'sample') return sampleModal;
    return null;
  };

  const resetQuoteWizardState = (options = {}) => {
    if (!quoteModal) return;
    const clearProducts = options.clearProducts === true;
    const form = quoteForm || quoteModal.querySelector('form');

    if (form) {
      form.reset();
      clearValidationErrors(form);
    }

    if (clearProducts) {
      state.quoteItems = [];
      state.quoteSelectorContext.clear();
      saveQuoteItems();
      clearQuoteDraft();
      renderQuoteItems();
    }

    if (quoteSearchInput) quoteSearchInput.value = '';
    if (quoteSearchResults) {
      clearQuoteSearchResults();
    }
    showQuoteStatus('', 'info');

    setQuoteWizardStep(1);
    syncQuoteProductsPayload();
    syncAutofill(quoteModal);
    quoteModal.querySelectorAll('.im-modal__feedback--success').forEach((node) => {
      node.hidden = true;
    });
    quoteModal.classList.remove('im-modal--submitted');
  };

  const clearModalFeedback = (modal) => {
    if (!modal) return;
    const form = modal.querySelector('form');
    if (!form) return;

    form.querySelectorAll('[data-im-dynamic-feedback]').forEach((node) => node.remove());
    modal.querySelectorAll('.im-modal__feedback--error, .im-modal__feedback--success').forEach((node) => {
      if (node.hasAttribute('data-im-modal-success')) {
        return;
      }
      if (node.hasAttribute('data-im-static-feedback')) {
        return;
      }
      if (node.classList.contains('im-modal__success')) {
        return;
      }
      if (node.hasAttribute('hidden')) return;
      node.hidden = true;
    });
  };

  const showModalError = (modal, message, options = {}) => {
    const form = modal ? modal.querySelector('form') : null;
    if (!form) return;
    clearModalFeedback(modal);

    const errorNode = document.createElement('div');
    errorNode.className = 'im-modal__feedback im-modal__feedback--error';
    errorNode.setAttribute('data-im-dynamic-feedback', '');
    const messageNode = document.createElement('span');
    messageNode.textContent = message;
    errorNode.appendChild(messageNode);
    if (options && options.retryable) {
      const retryButton = document.createElement('button');
      retryButton.type = 'button';
      retryButton.className = 'im-modal__feedback-retry';
      retryButton.textContent = 'Retry';
      retryButton.addEventListener('click', () => {
        clearModalFeedback(modal);
        if (typeof options.onRetry === 'function') {
          options.onRetry();
        }
      });
      errorNode.appendChild(retryButton);
    }
    form.insertBefore(errorNode, form.firstElementChild || null);
  };

  const showModalSuccess = (modal) => {
    if (!modal) return;
    clearModalFeedback(modal);

    if (modal === sampleModal) {
      const sampleEmail = getFieldValue(modal.querySelector('[data-im-field="email"]')) || 'your email';
      sampleSuccessEmailNodes.forEach((node) => {
        node.textContent = sampleEmail;
      });
    }

    const successPanel = modal.querySelector('[data-im-modal-success]');
    if (successPanel) {
      successPanel.hidden = false;
      modal.classList.add('im-modal--submitted');
      return;
    }

    const form = modal.querySelector('form');
    if (!form) return;
    const successNode = document.createElement('p');
    successNode.className = 'im-modal__feedback im-modal__feedback--success';
    successNode.setAttribute('data-im-dynamic-feedback', '');
    successNode.textContent = "Thanks for contacting us. We'll get back to you as soon as possible.";
    form.insertBefore(successNode, form.firstElementChild || null);
    modal.classList.add('im-modal--submitted');
  };

  const resetSubmittedModal = (modal) => {
    if (!modal) return;
    const form = modal.querySelector('form');
    if (form) {
      form.reset();
      clearValidationErrors(form);
    }

    modal.querySelectorAll('.im-modal__feedback--success').forEach((node) => {
      node.hidden = true;
    });
    clearModalFeedback(modal);
    modal.classList.remove('im-modal--submitted');

    if (modal === quoteModal) {
      resetQuoteWizardState({ clearProducts: true });
    }
    if (modal === sampleModal) {
      resetSampleWizardState({ clearItems: true });
    }
  };

  const openModal = (key, options = {}) => {
    const modal = findModalByKey(key);
    if (!modal) return;
    const skipQuoteAutoAdd = options && options.skipQuoteAutoAdd === true;
    const skipSampleAutoAdd = options && options.skipSampleAutoAdd === true;

    readVariantFromDom();
    const calculatorQuantity = parseCalculatorQuantity();
    if (calculatorQuantity !== null) {
      state.estimatedQuantity = calculatorQuantity;
    }

    if (key === 'quote' && !skipQuoteAutoAdd) {
      addCurrentProductToQuoteList({ onlyIfMissing: true });
    }
    if (key === 'sample' && !skipSampleAutoAdd && !state.sampleItems.length) {
      addCurrentProductToSampleList({ silent: true });
    }

    if (key === 'quote' && isQuoteWizardEnabled() && !modal.classList.contains('im-modal--submitted')) {
      setQuoteWizardStep(state.quoteWizardStep || 1);
      maybeAutofillQuoteLocation();
    }
    if (key === 'sample' && isSampleWizardEnabled() && !modal.classList.contains('im-modal--submitted')) {
      setSampleWizardStep(state.sampleWizardStep || 1);
      setSampleRegionRequirement();
      renderSampleSummary();
      refreshSampleSearchResults();
    }

    syncAutofill(modal);

    lockBodyScroll();
    document.body.classList.add('im-modal-open');

    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', 'open');
    }
  };

  const restoreSubmittedModalFromUrl = () => {
    let flow = '';
    try {
      const params = new URLSearchParams(window.location.search);
      const queryFlow = params.get(FORM_SUCCESS_QUERY_PARAM);
      if (queryFlow === 'quote' || queryFlow === 'sample') {
        flow = queryFlow;
      }
    } catch (error) {
      flow = '';
    }
    if (!flow) return;

    openModal(flow, { skipQuoteAutoAdd: true, skipSampleAutoAdd: true });
    const modal = flow === 'quote' ? quoteModal : sampleModal;
    if (!modal) return;
    showModalSuccess(modal);

    if (flow === 'quote' && isQuoteWizardEnabled()) {
      setQuoteWizardStep(QUOTE_WIZARD_TOTAL_STEPS);
    }
    if (flow === 'sample' && isSampleWizardEnabled()) {
      setSampleWizardStep(SAMPLE_WIZARD_TOTAL_STEPS);
    }

    try {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete(FORM_SUCCESS_QUERY_PARAM);
      const nextUrl = `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;
      window.history.replaceState({}, document.title, nextUrl);
    } catch (error) {
      // Ignore history replacement failures.
    }
  };

  const closeModal = (modal) => {
    if (!modal) return;

    if (modal.classList.contains('im-modal--submitted')) {
      resetSubmittedModal(modal);
    }

    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }

    if (!document.querySelector('dialog[data-im-modal][open]')) {
      document.body.classList.remove('im-modal-open');
      unlockBodyScroll();
    }
  };

  const inferModalKey = (trigger) => {
    if (!trigger) return null;

    const explicit = trigger.getAttribute('data-modal');
    if (explicit === 'quote' || explicit === 'sample') return explicit;

    const textValue = normalizeLabel(trigger.getAttribute('data-modal-label') || trigger.textContent || trigger.value || '');
    if (!textValue) return null;

    const quoteLabels = new Set(['request quote', 'request qoute', 'request a quote', 'start a project', 'project inquiry']);
    const sampleLabels = new Set(['order sample', 'order samples', 'get sample', 'get samples', 'request samples', 'request a sample', 'request sample']);

    if (quoteLabels.has(textValue)) return 'quote';
    if (sampleLabels.has(textValue)) return 'sample';
    return null;
  };

  const getCustomQuoteTriggerPayload = (trigger) => {
    if (!trigger) return null;

    const handle = String(trigger.getAttribute('data-im-quote-handle') || '').trim();
    if (!handle) return null;

    return {
      handle,
      productId: toNumber(trigger.getAttribute('data-im-quote-product-id')),
      productTitle: String(trigger.getAttribute('data-im-quote-product-title') || '').trim(),
      preferredVariantId: toNumber(trigger.getAttribute('data-im-quote-preferred-variant-id')),
    };
  };

  document.addEventListener('click', async (event) => {
    const closeTrigger = event.target.closest('[data-im-modal-close]');
    if (closeTrigger) {
      const modal = closeTrigger.closest('dialog[data-im-modal]');
      closeModal(modal);
      return;
    }

    const trigger = event.target.closest('[data-modal], button, a, input[type="button"], input[type="submit"]');
    if (!trigger) return;
    if (trigger.closest('dialog[data-im-modal]')) return;

    const modalKey = inferModalKey(trigger);
    if (!modalKey) return;

    event.preventDefault();
    if (modalKey === 'quote') {
      const customQuotePayload = getCustomQuoteTriggerPayload(trigger);
      if (customQuotePayload) {
        try {
          await addProductByHandleToQuoteList(
            customQuotePayload.handle,
            customQuotePayload.preferredVariantId,
            customQuotePayload,
            {
              strictPreferred: customQuotePayload.preferredVariantId !== null,
            }
          );
        } catch (error) {
          showQuoteStatus('Could not preload the selected product. You can add it inside the quote form.', 'warning');
        }

        openModal('quote', { skipQuoteAutoAdd: true });
        if (quoteProductsContainer) {
          revealListContainer(quoteProductsContainer);
        }
        return;
      }
    }

    openModal(modalKey);
  });

  if (quoteProductsContainer) {
    quoteProductsContainer.addEventListener('click', (event) => {
      const row = event.target.closest('[data-im-quote-key]');
      if (!row) return;
      const key = row.getAttribute('data-im-quote-key');
      if (!key) return;

      if (event.target.closest('[data-im-quote-remove]')) {
        removeQuoteItem(key);
        return;
      }

      if (event.target.closest('[data-im-quote-qty-dec]')) {
        const currentItem = state.quoteItems.find((item) => quoteItemKey(item) === key);
        if (!currentItem) return;
        const newQty = clampQuantity(currentItem.quantity - 10);
        updateQuoteItemQuantity(key, newQty, { rerender: false });
        const qtyInput = row.querySelector('[data-im-quote-qty]');
        if (qtyInput) qtyInput.value = String(newQty);
        const pEl = row.querySelector('[data-im-quote-pricing]');
        if (pEl) updateQuotePricingNode(pEl, row.getAttribute('data-im-quote-handle') || '', newQty);
        animateQuantitySaved(row);
        return;
      }

      if (event.target.closest('[data-im-quote-qty-inc]')) {
        const currentItem = state.quoteItems.find((item) => quoteItemKey(item) === key);
        if (!currentItem) return;
        const newQty = clampQuantity(currentItem.quantity + 10);
        updateQuoteItemQuantity(key, newQty, { rerender: false });
        const qtyInput = row.querySelector('[data-im-quote-qty]');
        if (qtyInput) qtyInput.value = String(newQty);
        const pEl = row.querySelector('[data-im-quote-pricing]');
        if (pEl) updateQuotePricingNode(pEl, row.getAttribute('data-im-quote-handle') || '', newQty);
        animateQuantitySaved(row);
      }
    });

    const animateQuantitySaved = (row) => {
      if (!row) return;
      const qtyRow = row.querySelector('.im-quote-products__qty-row');
      if (!qtyRow) return;
      qtyRow.classList.remove('is-saved');
      void qtyRow.offsetWidth;
      qtyRow.classList.add('is-saved');
      window.setTimeout(() => {
        qtyRow.classList.remove('is-saved');
      }, 520);
    };

    const updateFromInput = (target, forceCommit) => {
      const qtyInput = target.closest('[data-im-quote-qty]');
      if (!qtyInput) return;
      const row = qtyInput.closest('[data-im-quote-key]');
      if (!row) return;
      const key = row.getAttribute('data-im-quote-key');
      if (!key) return;

      const normalizedRaw = String(qtyInput.value || '').replace(/[^\d]/g, '');
      if (normalizedRaw !== qtyInput.value) {
        qtyInput.value = normalizedRaw;
      }

      if (!qtyInput.value) {
        if (forceCommit) {
          qtyInput.value = '1';
          updateQuoteItemQuantity(key, 1, { rerender: false });
          animateQuantitySaved(row);
        }
        return;
      }

      const quantity = clampQuantity(qtyInput.value);
      if (forceCommit) {
        qtyInput.value = String(quantity);
      }
      updateQuoteItemQuantity(key, quantity, { rerender: false });
      const pricingEl = row.querySelector('[data-im-quote-pricing]');
      if (pricingEl) {
        updateQuotePricingNode(pricingEl, row.getAttribute('data-im-quote-handle') || '', quantity);
      }
      if (forceCommit) {
        animateQuantitySaved(row);
      }
    };

    quoteProductsContainer.addEventListener('input', (event) => updateFromInput(event.target, false));
    quoteProductsContainer.addEventListener('change', (event) => updateFromInput(event.target, true));
    quoteProductsContainer.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      const qtyInput = event.target.closest('[data-im-quote-qty]');
      if (!qtyInput) return;
      event.preventDefault();
      updateFromInput(qtyInput, true);
    });
    quoteProductsContainer.addEventListener(
      'focusout',
      (event) => {
        if (!event.target.closest('[data-im-quote-qty]')) return;
        updateFromInput(event.target, true);
      },
      true
    );

    quoteProductsContainer.addEventListener('change', (event) => {
      const select = event.target.closest('[data-im-quote-variant-select]');
      if (!select) return;
      const row = select.closest('[data-im-quote-key]');
      if (!row) return;
      const key = row.getAttribute('data-im-quote-key');
      if (!key) return;
      const previousVariantId = row.getAttribute('data-im-quote-variant-id') || '';
      const result = updateQuoteItemVariant(key, select.value);
      if (!result || result.ok) return;
      if (previousVariantId) {
        select.value = previousVariantId;
      }
    });
  }

  if (quoteSearchInput && quoteSearchResults) {
    clearQuoteSearchResults();

    if (quoteLoadAllButton) {
      quoteLoadAllButton.addEventListener('click', async () => {
        if (quoteCatalogLoading) return;

        quoteLoadAllButton.disabled = true;
        const originalLabel = quoteLoadAllButton.textContent;
        quoteLoadAllButton.textContent = 'Loading catalog...';
        renderQuoteSearchMessage('Loading all products...');

        try {
          await loadQuoteCatalog();
          quoteLoadAllButton.textContent = 'Catalog ready';
          runQuoteSearch(quoteSearchInput.value);
        } catch (error) {
          quoteLoadAllButton.textContent = 'Retry loading catalog';
          renderQuoteSearchMessage('Could not load product catalog right now. Please try again.');
        } finally {
          window.setTimeout(() => {
            quoteLoadAllButton.disabled = false;
            quoteLoadAllButton.textContent = originalLabel || 'Browse all products';
          }, 700);
        }
      });
    }

    quoteSearchInput.addEventListener('input', (event) => {
      if (quoteSearchTimer) {
        window.clearTimeout(quoteSearchTimer);
      }

      quoteSearchTimer = window.setTimeout(() => {
        runQuoteSearch(event.target.value);
      }, 220);
    });

    quoteSearchInput.addEventListener('focus', async () => {
      const currentValue = String(quoteSearchInput.value || '').trim();
      if (quoteCatalogLoaded) {
        if (!currentValue) {
          runQuoteSearch('');
        }
        return;
      }
      if (quoteCatalogLoading || quoteSearchAutoLoaded) return;

      quoteSearchAutoLoaded = true;
      renderQuoteSearchMessage('Loading all products...');
      try {
        await loadQuoteCatalog();
        runQuoteSearch(currentValue);
      } catch (error) {
        quoteSearchAutoLoaded = false;
        renderQuoteSearchMessage('Could not load product catalog right now. Please try again.');
      }
    });

    quoteSearchInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (quoteSearchTimer) {
        window.clearTimeout(quoteSearchTimer);
      }
      runQuoteSearch(quoteSearchInput.value);
    });

    quoteSearchResults.addEventListener('click', async (event) => {
      const addButton = event.target.closest('[data-im-quote-search-add]');
      if (!addButton) return;
      if (addButton.disabled) return;

      const handle = String(addButton.getAttribute('data-im-quote-handle') || '').trim();
      if (!handle) return;

      const payload = {
        productId: toNumber(addButton.getAttribute('data-im-quote-product-id')),
        productTitle: String(addButton.getAttribute('data-im-quote-product-title') || '').trim(),
        preferredVariantId: toNumber(addButton.getAttribute('data-im-quote-preferred-variant-id')),
      };

      addButton.disabled = true;
      addButton.textContent = 'Adding...';

      try {
        const result = await addProductByHandleToQuoteList(handle, payload.preferredVariantId, payload, {
          strictPreferred: true,
        });
        if (result && result.ok === false) {
          const addLimitState = getQuoteSearchResultState(handle, payload.preferredVariantId);
          addButton.textContent = addLimitState.label;
          addButton.disabled = addLimitState.reason !== 'can-add';
          refreshQuoteSearchResults();
          return;
        }
        addButton.textContent = 'Added';
        revealListContainer(quoteProductsContainer);
        window.setTimeout(() => {
          refreshQuoteSearchResults();
        }, 120);
      } catch (error) {
        addButton.textContent = 'Retry';
        addButton.disabled = false;
      } finally {
        if (addButton.textContent === 'Added') {
          window.setTimeout(() => {
            refreshQuoteSearchResults();
          }, 460);
        }
      }
    });
  }

  if (sampleLinesContainer) {
    sampleLinesContainer.addEventListener('click', (event) => {
      const row = event.target.closest('[data-im-sample-line-id]');
      if (!row) return;
      const lineId = row.getAttribute('data-im-sample-line-id');
      if (!lineId) return;

      if (event.target.closest('[data-im-sample-remove]')) {
        removeSampleItem(lineId);
        return;
      }

      if (event.target.closest('[data-im-sample-qty-dec]')) {
        const current = state.sampleItems.find((item) => item.lineId === lineId);
        if (!current) return;
        updateSampleItemQuantity(lineId, clampSampleQuantity(current.quantity) - 1, { silent: true });
        return;
      }

      if (event.target.closest('[data-im-sample-qty-inc]')) {
        const current = state.sampleItems.find((item) => item.lineId === lineId);
        if (!current) return;
        updateSampleItemQuantity(lineId, clampSampleQuantity(current.quantity) + 1, { silent: false });
      }
    });

    const commitSampleQuantity = (target, forceCommit) => {
      const qtyInput = target.closest('[data-im-sample-qty]');
      if (!qtyInput) return;
      const row = qtyInput.closest('[data-im-sample-line-id]');
      if (!row) return;
      const lineId = row.getAttribute('data-im-sample-line-id');
      if (!lineId) return;

      const normalizedRaw = String(qtyInput.value || '').replace(/[^\d]/g, '');
      if (normalizedRaw !== qtyInput.value) {
        qtyInput.value = normalizedRaw;
      }

      if (!qtyInput.value) {
        if (forceCommit) {
          qtyInput.value = '1';
          updateSampleItemQuantity(lineId, 1, { silent: true });
        }
        return;
      }

      const quantity = clampSampleQuantity(qtyInput.value);
      if (forceCommit) {
        qtyInput.value = String(quantity);
      }
      updateSampleItemQuantity(lineId, quantity, { silent: !forceCommit });
    };

    sampleLinesContainer.addEventListener('input', (event) => commitSampleQuantity(event.target, false));
    sampleLinesContainer.addEventListener('change', (event) => {
      commitSampleQuantity(event.target, true);
      const select = event.target.closest('[data-im-sample-variant-select]');
      if (!select) return;
      const row = select.closest('[data-im-sample-line-id]');
      if (!row) return;
      const lineId = row.getAttribute('data-im-sample-line-id');
      if (!lineId) return;
      const previous = state.sampleItems.find((item) => item.lineId === lineId);
      const previousToken = toNumber(previous && previous.variantId);
      const result = updateSampleItemVariant(lineId, select.value);
      if (result && result.ok) return;
      select.value = previousToken === null ? SAMPLE_ANY_VARIANT_VALUE : String(previousToken);
    });
    sampleLinesContainer.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      const qtyInput = event.target.closest('[data-im-sample-qty]');
      if (!qtyInput) return;
      event.preventDefault();
      commitSampleQuantity(qtyInput, true);
    });
    sampleLinesContainer.addEventListener(
      'focusout',
      (event) => {
        if (!event.target.closest('[data-im-sample-qty]')) return;
        commitSampleQuantity(event.target, true);
      },
      true
    );
  }

  if (sampleSearchInput && sampleSearchResults) {
    clearSampleSearchResults();

    if (sampleLoadAllButton) {
      sampleLoadAllButton.addEventListener('click', async () => {
        if (quoteCatalogLoading) return;
        sampleLoadAllButton.disabled = true;
        const originalLabel = sampleLoadAllButton.textContent;
        sampleLoadAllButton.textContent = 'Loading catalog...';
        renderSampleSearchMessage('Loading all products...');
        try {
          await loadQuoteCatalog();
          sampleLoadAllButton.textContent = 'Catalog ready';
          runSampleSearch(sampleSearchInput.value || '');
        } catch (error) {
          sampleLoadAllButton.textContent = 'Retry loading catalog';
          renderSampleSearchMessage('Could not load product catalog right now. Please try again.');
        } finally {
          window.setTimeout(() => {
            sampleLoadAllButton.disabled = false;
            sampleLoadAllButton.textContent = originalLabel || 'Browse all products';
          }, 700);
        }
      });
    }

    sampleSearchInput.addEventListener('input', (event) => {
      if (sampleSearchTimer) {
        window.clearTimeout(sampleSearchTimer);
      }
      sampleSearchTimer = window.setTimeout(() => {
        runSampleSearch(event.target.value);
      }, 220);
    });

    sampleSearchInput.addEventListener('focus', async () => {
      const currentValue = String(sampleSearchInput.value || '').trim();
      if (quoteCatalogLoaded) {
        if (!currentValue) {
          runSampleSearch('');
        }
        return;
      }
      if (quoteCatalogLoading || sampleSearchAutoLoaded) return;

      sampleSearchAutoLoaded = true;
      renderSampleSearchMessage('Loading all products...');
      try {
        await loadQuoteCatalog();
        runSampleSearch(currentValue);
      } catch (error) {
        sampleSearchAutoLoaded = false;
        renderSampleSearchMessage('Could not load product catalog right now. Please try again.');
      }
    });

    sampleSearchInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (sampleSearchTimer) {
        window.clearTimeout(sampleSearchTimer);
      }
      runSampleSearch(sampleSearchInput.value || '');
    });

    sampleSearchResults.addEventListener('click', async (event) => {
      const addButton = event.target.closest('[data-im-sample-search-add]');
      if (!addButton || addButton.disabled) return;
      const handle = String(addButton.getAttribute('data-im-sample-handle') || '').trim();
      if (!handle) return;
      addButton.disabled = true;
      const originalLabel = addButton.textContent;
      addButton.textContent = 'Adding...';
      try {
        const preferredVariantId = toNumber(addButton.getAttribute('data-im-sample-preferred-variant-id'));
        const result = await addProductByHandleToSampleList(handle, {
          productId: toNumber(addButton.getAttribute('data-im-sample-product-id')),
          productTitle: String(addButton.getAttribute('data-im-sample-title') || '').trim(),
          preferredVariantId,
        }, {
          preferredVariantId,
        });
        if (!result || !result.ok) {
          addButton.textContent = 'Retry';
          addButton.disabled = false;
          return;
        }
        addButton.textContent = 'Added';
        revealListContainer(sampleLinesContainer);
        window.setTimeout(() => {
          refreshSampleSearchResults();
        }, 140);
      } catch (error) {
        addButton.textContent = 'Retry';
        addButton.disabled = false;
      } finally {
        window.setTimeout(() => {
          if (!addButton.isConnected) return;
          if (addButton.textContent === 'Retry') return;
          addButton.textContent = originalLabel || getSampleAddLabel();
          refreshSampleSearchResults();
        }, 640);
      }
    });
  }

  const initQuoteWizard = () => {
    if (!isQuoteWizardEnabled() || !quoteModal) return;
    const wizardForm = quoteForm || quoteModal.querySelector('form');
    if (!wizardForm) return;

    quoteModal.classList.add('im-modal--wizard-ready');
    wizardForm.noValidate = true;
    if (quoteWizardFallbackSubmit) {
      quoteWizardFallbackSubmit.hidden = true;
      quoteWizardFallbackSubmit.type = 'button';
    }
    if (quoteWizardSubmitButton) {
      quoteWizardSubmitButton.type = 'button';
    }

    quoteWizardSteps.forEach((stepNode, index) => {
      const isActive = index === 0;
      stepNode.classList.toggle('is-active', isActive);
      stepNode.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    setQuoteWizardStep(state.quoteWizardStep || 1);

    quoteWizardBackButton.addEventListener('click', () => {
      setQuoteWizardStep(state.quoteWizardStep - 1, { focusFirstField: true });
    });

    quoteWizardNextButton.addEventListener('click', () => {
      const result = validateQuoteStep(state.quoteWizardStep, { focusInvalid: true });
      if (!result.valid) return;
      setQuoteWizardStep(state.quoteWizardStep + 1, { focusFirstField: true });
    });

    quoteWizardSubmitButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      submitModalWithValidation(quoteModal, wizardForm);
    });

    wizardForm.addEventListener('input', (event) => {
      const field = event.target.closest('input, select, textarea');
      if (!field) return;
      if (field.checkValidity()) clearFieldError(field);
      if (field.closest('[data-im-step="2"]') && state.quoteItems.length) {
        hideQuoteProductsError();
      }
      saveQuoteDraft();
    });

    wizardForm.addEventListener('change', (event) => {
      const field = event.target.closest('input, select, textarea');
      if (!field) return;
      if (field.checkValidity()) clearFieldError(field);
      saveQuoteDraft();
    });

    wizardForm.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (event.defaultPrevented) return;
      const target = event.target;
      if (!target || target.tagName === 'TEXTAREA') return;
      const submitterLike = target.closest('[data-im-wizard-submit]');
      if (submitterLike) return;
      event.preventDefault();
    });
  };

  applyQuoteDraft();
  renderQuoteEmailSuggestions();
  initQuoteWizard();
  initSampleWizard();

  const scheduleSampleCurrencyRefresh = () => {
    window.requestAnimationFrame(() => {
      refreshSamplePricingForCurrency();
    });
  };
  document.addEventListener('im:currency:change', scheduleSampleCurrencyRefresh);
  document.addEventListener('im:currency:change', () => {
    window.requestAnimationFrame(refreshAllQuotePricing);
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-im-currency-btn]')) return;
    window.setTimeout(() => {
      refreshSamplePricingForCurrency();
      refreshAllQuotePricing();
    }, 0);
  });
  window.addEventListener('storage', (event) => {
    if (!event || event.key !== 'im_currency') return;
    scheduleSampleCurrencyRefresh();
    refreshAllQuotePricing();
  });

  const getFlowByModal = (modal) => {
    if (modal === quoteModal) return 'quote';
    if (modal === sampleModal) return 'sample';
    return '';
  };

  const maskDebugPayloadValue = (key, value) => {
    const normalizedKey = String(key || '').toLowerCase();
    const raw = String(value || '');
    if (!raw) return '';
    if (normalizedKey.includes('email')) {
      const parts = raw.split('@');
      if (parts.length === 2) {
        const user = parts[0];
        const maskedUser =
          user.length <= 2 ? `${user.charAt(0)}***` : `${user.slice(0, 2)}***${user.slice(-1)}`;
        return `${maskedUser}@${parts[1]}`;
      }
      return '***';
    }
    if (normalizedKey.includes('phone') || normalizedKey.includes('postal') || normalizedKey.includes('vat')) {
      return `${raw.slice(0, 2)}***`;
    }
    if (
      normalizedKey.includes('body') ||
      normalizedKey.includes('payload') ||
      normalizedKey.includes('notes') ||
      normalizedKey.includes('note')
    ) {
      return `[length:${raw.length}]`;
    }
    if (raw.length > 120) return `${raw.slice(0, 117)}...`;
    return raw;
  };

  const sanitizeDebugPayload = (payload) => {
    const sanitized = {};
    if (payload instanceof URLSearchParams) {
      payload.forEach((value, key) => {
        sanitized[key] = maskDebugPayloadValue(key, value);
      });
      return sanitized;
    }
    if (payload instanceof FormData) {
      payload.forEach((value, key) => {
        if (typeof value === 'string') {
          sanitized[key] = maskDebugPayloadValue(key, value);
        }
      });
      return sanitized;
    }
    const params = new URLSearchParams(String(payload || ''));
    params.forEach((value, key) => {
      sanitized[key] = maskDebugPayloadValue(key, value);
    });
    return sanitized;
  };

  const resolveContactEndpoint = (form) => {
    const actionAttr = String(form && form.getAttribute('action') ? form.getAttribute('action') : '').trim();
    if (!actionAttr) return buildShopifyUrl('contact');
    try {
      const parsed = new URL(actionAttr, window.location.origin);
      return `${parsed.pathname || '/contact'}${parsed.search || ''}`;
    } catch (error) {
      return actionAttr.split('#')[0] || buildShopifyUrl('contact');
    }
  };

  const buildReturnToPath = (flow) => {
    const normalizedFlow = flow === 'sample' ? 'sample' : 'quote';
    try {
      const current = new URL(window.location.href);
      current.hash = '';
      current.searchParams.set(FORM_SUCCESS_QUERY_PARAM, normalizedFlow);
      current.searchParams.delete('contact_posted');
      current.searchParams.delete('customer_posted');
      return `${current.pathname}${current.search}`;
    } catch (error) {
      return `${window.location.pathname || '/'}?${FORM_SUCCESS_QUERY_PARAM}=${normalizedFlow}`;
    }
  };

  const toSubmitDebugDetail = (meta = {}) => {
    const parts = [];
    if (meta.status) {
      parts.push(`HTTP ${meta.status}${meta.statusText ? ` ${meta.statusText}` : ''}`);
    }
    if (meta.requestId) {
      parts.push(`x-request-id ${meta.requestId}`);
    }
    if (meta.reason) {
      parts.push(meta.reason);
    }
    return parts.join(' | ');
  };

  const createSubmitError = (message, meta = {}) => {
    const error = new Error(message);
    error.imDebugDetail = toSubmitDebugDetail(meta);
    return error;
  };

  const isCaptchaSubmitError = (error) => {
    const message = String(error && error.message ? error.message : '').toLowerCase();
    const detail = String(error && error.imDebugDetail ? error.imDebugDetail : '').toLowerCase();
    return message.includes('captcha') || detail.includes('captcha');
  };

  const submitInquiryNatively = (form, flow) => {
    if (!form) {
      throw createSubmitError('Could not submit. Missing inquiry form.');
    }

    const endpoint = resolveContactEndpoint(form);
    const returnToField =
      form.querySelector('[data-im-return-to]') ||
      form.querySelector('input[name="return_to"]');
    if (returnToField) {
      returnToField.value = buildReturnToPath(flow);
    }

    const debugStart = {
      endpoint,
      method: 'POST',
      mode: `${flow}-contact-native`,
      payload: sanitizeDebugPayload(new FormData(form)),
      status: 'native-submit-started',
      statusText: '',
      requestId: '',
      responseUrl: '',
      responseBody: '',
    };
    window.__IM_LAST_SUBMIT_DEBUG = debugStart;
    logSubmitDebug('Inquiry native submit start', debugStart);

    const performNativeSubmit = () => {
      form.dataset.imAllowNativeSubmit = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else if (typeof form.submit === 'function') {
        form.submit();
      }
    };

    const captchaApi =
      window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function'
        ? window.Shopify.captcha
        : null;
    form.setAttribute('data-shopify-captcha', 'true');

    if (!captchaApi) {
      performNativeSubmit();
      return;
    }

    try {
      captchaApi.protect(form, () => {
        performNativeSubmit();
      });
    } catch (error) {
      performNativeSubmit();
    }
  };

  const submitModalFormAjax = async (modal, form) => {
    if (!modal || !form) throw createSubmitError('Could not submit. Missing form.');
    const flow = getFlowByModal(modal);
    if (!flow) throw createSubmitError('Could not submit. Unknown form flow.');

    form.setAttribute('data-shopify-captcha', 'true');

    const leadPayload = buildLeadDataForModal(modal, form);
    if (!leadPayload || !leadPayload.email) {
      throw createSubmitError('Could not submit your request. Missing contact email.');
    }

    const returnToField =
      form.querySelector('[data-im-return-to]') ||
      form.querySelector('input[name="return_to"]');
    if (returnToField) {
      returnToField.value = '';
    }

    try {
      await submitInquiryInBackground(form, flow);
      showModalSuccess(modal);
      if (leadPayload.marketingConsent) {
        window.setTimeout(() => {
          submitLeadUpsertForModal(modal, form, flow, leadPayload).catch((error) => {
            if (window.console && typeof window.console.warn === 'function') {
              window.console.warn('[IM Submit Debug] Lead upsert failed after inquiry submit:', error);
            }
          });
        }, 0);
      }
      if (modal === sampleModal) {
        window.setTimeout(() => {
          submitSampleDraftOrderForModal(modal, form).catch((error) => {
            if (window.console && typeof window.console.warn === 'function') {
              window.console.warn('[IM Submit Debug] Sample draft order failed after inquiry submit:', error);
            }
          });
        }, 0);
      }
      if (modal === quoteModal) {
        window.setTimeout(() => {
          submitQuoteDraftOrderForModal(modal, form).catch((error) => {
            if (window.console && typeof window.console.warn === 'function') {
              window.console.warn('[IM Submit Debug] Quote draft order failed after inquiry submit:', error);
            }
          });
        }, 0);
      }
      return 'background-submitted';
    } catch (error) {
      if (!isCaptchaSubmitError(error)) {
        throw error;
      }

      if (leadPayload.marketingConsent) {
        try {
          await submitLeadUpsertForModal(modal, form, flow, leadPayload);
        } catch (upsertError) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('[IM Submit Debug] Lead upsert failed before native fallback:', upsertError);
          }
        }
      }
      submitInquiryNatively(form, flow);
      return 'native-fallback-submitted';
    }
  };

  const submitModalWithValidation = async (modal, form) => {
    if (!modal || !form) return;
    if (form.dataset.imSubmitting === 'true') return;
    if (modal === quoteModal || modal === sampleModal) {
      clearModalFeedback(modal);
    }

    if (modal === quoteModal) {
      if (isQuoteWizardEnabled() && state.quoteWizardStep !== QUOTE_WIZARD_TOTAL_STEPS) {
        return;
      }

      const validation = validateAllQuoteSteps();
      if (!validation.valid) {
        if (isQuoteWizardEnabled()) {
          setQuoteWizardStep(validation.step, { focusFirstField: false });
        }
        if (validation.firstInvalid && typeof validation.firstInvalid.focus === 'function') {
          window.requestAnimationFrame(() => validation.firstInvalid.focus());
        }
        return;
      }
    }
    if (modal === sampleModal) {
      if (isSampleWizardEnabled() && state.sampleWizardStep !== SAMPLE_WIZARD_TOTAL_STEPS) {
        return;
      }
      const validation = validateAllSampleSteps();
      if (!validation.valid) {
        if (isSampleWizardEnabled()) {
          setSampleWizardStep(validation.step, { focusFirstField: false });
        }
        if (validation.firstInvalid && typeof validation.firstInvalid.focus === 'function') {
          window.requestAnimationFrame(() => validation.firstInvalid.focus());
        }
        return;
      }
    }

    if (!form.checkValidity()) {
      const invalidField = form.querySelector(':invalid');
      if (invalidField && typeof invalidField.focus === 'function') {
        if (modal === quoteModal || modal === sampleModal) {
          validateField(invalidField);
        } else if (typeof invalidField.reportValidity === 'function') {
          invalidField.reportValidity();
        }
        window.requestAnimationFrame(() => invalidField.focus());
      }
      return;
    }

    form.dataset.imSubmitting = 'true';
    const submitButtons = Array.from(form.querySelectorAll(
      'button[type="submit"], button[data-im-wizard-submit], button[data-im-sample-submit]'
    ));
    const submitButtonState = submitButtons.map((button) => ({
      button,
      label: button.textContent,
    }));
    submitButtons.forEach((button) => {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Submitting...';
      button.disabled = true;
    });

    try {
      clearModalFeedback(modal);
      syncAutofill(form);
      prepareFormPayload(form);
      if (modal === quoteModal) {
        const submittedQuoteEmail = getFieldValue(form.querySelector('[data-im-field="email"]'));
        rememberQuoteEmail(submittedQuoteEmail);
        fireQuoteDraftOrderUpfront(modal, form);
      }
      if (modal === sampleModal) {
        hideSampleLinesError();
        fireSampleDraftOrderUpfront(modal, form);
      }

      await submitModalFormAjax(modal, form);
    } catch (error) {
      const baseMessage = error && error.message ? error.message : 'Could not submit. Please try again.';
      const debugSuffix =
        isFormDebugMode && error && error.imDebugDetail ? ` (${error.imDebugDetail})` : '';
      showModalError(modal, `${baseMessage}${debugSuffix}`, {
        retryable: true,
        onRetry: () => {
          window.requestAnimationFrame(() => {
            submitModalWithValidation(modal, form);
          });
        },
      });
    } finally {
      form.dataset.imSubmitting = 'false';
      submitButtonState.forEach(({ button, label }) => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.textContent = label;
        button.disabled = false;
      });
    }
  };

  [quoteModal, sampleModal].forEach((modal) => {
    if (!modal) return;

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
      }
    });

    modal.addEventListener('close', () => {
      if (!document.querySelector('dialog[data-im-modal][open]')) {
        document.body.classList.remove('im-modal-open');
        unlockBodyScroll();
      }
    });

    const form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', async (event) => {
        if (form.dataset.imAllowNativeSubmit === 'true') {
          window.setTimeout(() => {
            form.dataset.imAllowNativeSubmit = '';
          }, 0);
          return;
        }
        if (form.dataset.imCaptureCaptchaSubmit === 'true') {
          return;
        }
        event.preventDefault();
        // Quote modal submission is handled only by explicit wizard submit button click.
        if (modal === quoteModal) return;
        await submitModalWithValidation(modal, form);
      });
    }
  });

  document.addEventListener('im:calculator:update', (event) => {
    const quantity = event && event.detail ? Number(event.detail.quantity) : NaN;
    if (Number.isFinite(quantity) && quantity > 0) {
      state.estimatedQuantity = clampQuantity(quantity);
      syncAutofill(document);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data ? event.data.variant : null;
      if (!variant) return;
      state.variant = variant;
      if (state.productHandle && variant.id) {
        setQuoteSelectorVariant(state.productHandle, variant.id);
      }
      syncAutofill(document);
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target || event.target.name !== 'id') return;
    const variant = getVariantById(event.target.value);
    if (!variant) return;
    state.variant = variant;
    if (state.productHandle && variant.id) {
      setQuoteSelectorVariant(state.productHandle, variant.id);
    }
    syncAutofill(document);
  });

  state.quoteItems = loadQuoteItems();
  renderQuoteItems();
  hydrateQuoteVariantOptions();
  readVariantFromDom();

  const calculatorQuantity = parseCalculatorQuantity();
  if (calculatorQuantity !== null) state.estimatedQuantity = calculatorQuantity;

  syncAutofill(document);
  restoreSubmittedModalFromUrl();
})();
